<template>
  <div>
    <b-alert v-for="r in expiryReminders" :key="'exp'+r.id" show variant="warning" class="mb-3">{{ expiryReminderText(r) }}</b-alert>
    <div class="content-loader" v-show="false">
      <div class="loader"></div>
    </div>
    <b-toast
      id="toast-check-calendar"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-check.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>
    <b-toast
      id="toast-equis-calendar"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-equis.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>
    <b-toast
      id="toast-equis-calendar-modal"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-equis.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>
    <b-toast
      id="toast-equis-calendar"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-equis.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      <span v-html="message"></span>
    </b-toast>
    <b-toast id="message-toast" no-auto-hide>
      {{$t('horario.toast.text-1')}}
    </b-toast>
    <b-toast id="toast-check-nav-bar" variant="none" no-close-button toaster="b-toaster-top-center">
      <img src="@/assets/img/ico-check.png" style="margin-right: 10px; margin-top: -2px" />
      {{ message }}
    </b-toast>
    
    <!-- <b-breadcrumb :items="items"></b-breadcrumb> -->
    <b-breadcrumb>
  
      <b-breadcrumb-item to="/horario">{{$t('horario.breadcrumb.titulo')}}</b-breadcrumb-item>
      <template v-if="tabIndex==0">
        <b-breadcrumb-item to="/horario/calendario/public" :active="titleTeacher" @click="titleTeacher=true">{{$t('horario.breadcrumb.calendario-1.1')}}</b-breadcrumb-item>
        <b-breadcrumb-item active v-if="!titleTeacher">{{$t('horario.breadcrumb.calendario-1.2')}}</b-breadcrumb-item>
      </template>
      <template v-else>
         <b-breadcrumb-item to="/horario/calendario/private" :active="RequestDirectEmit==3" v-if="RequestDirectEmit==1" @click="RequestDirectEmit=0">{{$t('horario.breadcrumb.calendario-2.1')}}</b-breadcrumb-item>
         <b-breadcrumb-item to="/horario/calendario/private" :active="!RequestDirectEmit==0"  v-if="RequestDirectEmit==0" @click="RequestDirectEmit=0">{{$t('horario.breadcrumb.calendario-1.1')}}</b-breadcrumb-item>
         <b-breadcrumb-item :active="RequestDirectEmit==0" v-if="RequestDirectEmit==0">{{$t('horario.breadcrumb.calendario-1.2')}}</b-breadcrumb-item>
        <b-breadcrumb-item active v-if="RequestDirectEmit==1">{{$t('horario.breadcrumb.calendario-2.2')}}</b-breadcrumb-item>
      </template>
    </b-breadcrumb>
    <b-tabs class="calendar" v-model="tabIndex">
      <b-modal
        id="modal-notes"
        :hide-footer="true"
        :hide-header="true"
        :centered="true"
      >
        <div class="img_modal">
          <img src="@/assets/img/modal_notes.png" alt="" />
        </div>
        <div class="content">
          <img
            class="close"
            src="@/assets/img/close_red.png"
            @click="$bvModal.hide('modal-notes')"
          />
          <p class="text-justify">
            {{ flagPlanTest ? $t('horario.modal-notes.text-1-test-class') : $t('horario.modal-notes.text-1')}}
          </p>
          <p class="text-justify">
            {{ flagPlanTest ? $t('horario.modal-notes.text-2-test-class') : $t('horario.modal-notes.text-2')}}
          </p>
          <b-button
            variant="primary"
            @click="subirHorario(true)"
            :class="{ loading: showSpinner }"
          >
            {{$t('horario.modal-notes.text-3')}}
          </b-button>
        </div>
      </b-modal>
     
      <b-tab lazy :title="$t('horario.calendario.tabs.1')" :active="!disabledTabs" @click="changeActivityTab(1)" >
      <!-- :disabled="disabledTabs"-->
         <div v-if="showLoadingFirst" class="container-loading">
            <b-spinner :label="$t('reusables.loading')" ></b-spinner>
        </div>

        <div v-else-if="FlagGroupRegisterSubject">
          <div class="header-calendar">
            <b-alert
              :show="dismissCountDown"
              dismissible
              variant="warning"
              @dismissed="dismissCountDown = 0"
              @dismiss-count-down="countDownChanged"
            >
              {{$t('horario.calendario.text.1')}} {{ dismissCountDown }}
            </b-alert>
            <div class="back-step mt-0"  @click="getListHourChild" v-if="!titleTeacher">
              <icon name="arrow-left" />{{$t('horario.calendario.go-back')}}
            </div>
            <template v-if="!totalCarousel">
               <h6 v-if="showTitleCalendar" class="title-tab">
                 <!--<template v-if="$store.state.datosSidebar.flagEdited">
                    {{ $t('horario.calendario.titulo-change-class') }}
                    <span class="material-icons-outlined ml-3" 
                      v-b-tooltip.hover :title="$t('title.10')">info
                    </span>
                 </template>-->
                 <template>
                    {{ flagPlanTest ?  $t('horario.calendario.titulo-test-class') : $t('horario.calendario.titulo')}}
                    <icon v-if="!flagPlanTest" name="info" class="ml-3" v-b-tooltip.hover :title="$t('title.10')"/>
                 </template>
              
              </h6> 
              <h6 v-else class="title-tab">
                  {{$t('horario.calendario.else-titulo')}}
             
              </h6>
            </template>
           
            <template v-if="totalCarousel">
              <p class="title-carousel" v-if="titleTeacher">
                <a href="#" @click="showEventCarousel">{{numberTeacher}} 
                  <template v-if="numberTeacher===1">{{$t('horario.carousel.number-teacher-2')}} </template>
                  <template v-else>{{$t('horario.carousel.number-teacher')}} </template>
                  </a> 
                  <template v-if="numberTeacher===1"> {{$t('horario.carousel.text-2')}}</template>  <template v-else> {{$t('horario.carousel.text-1')}}</template>
              </p>
              <!--v-if="btnOutCarousel"-->
              <template >
              <div :key="'div_teacher_public_'+arrayListTeacherDetail.length" >
                <carousel
                  :mouseDrag="false"
                  :touchDrag="false"
                  :center ="false"
                  :margin = "10"
                  :nav="false"
                  :items="3"
                  :responsive="{1920:{items:4}}"
                  id="items-carousel">
                  <!--:class="{active : index == 0}"-->
                  <div @click="getDetailTeacher(item.id,item.personTeacherId,`teacher-id-${item.id}`,item.personTeacher.person.strFullName,item,index)" :id="`teacher-id-${item.id}`" class="card card_teacher card_teacher_carousel"  v-for="(item,index) in arrayListTeacherDetail" :key="`teacher-${index}`">
                    <div class="d-flex">
                      <div class="perfil">
                        <b-avatar size="3rem"
                          variant="light"
                          :src="item.personTeacher.person.photo != null ? item.personTeacher.person.photo :  urlPhoto"
                        ></b-avatar>
                        <b-form-rating :value="item.personTeacher.totalQualification" no-border readonly></b-form-rating>
                        <b-link @click="getTeacherInformationAndComments(item.personTeacherId)" >{{item.personTeacher.totalCommentary}} {{$t('horario.carousel.opinions')}}</b-link>
                      </div>
                      <div class="info">
                        <span class="status" style="font-weight:bold;" 
                        :style="{color:item.color }"
                        
                        >{{item.stateProposal.name}}</span>
                        <h6 @click="getDetailTeacher(item.id,item.personTeacherId,`teacher-id-${item.id}`,item.personTeacher.person.strFullName,item,index)">{{`${item.personTeacher.person.firstName} ${item.personTeacher.person.lastName}`}}</h6>
                        <p>
                          <icon name="location" />{{item.personTeacher.person.countryOriginDescription}}
                        </p>
                      </div>
                    </div>
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <b-icon v-if="item.personTeacher.urlVideoFormat != null && item.personTeacher.urlVideoFormat != ''" class="icon" icon="youtube"  @click="getModalVideo(item.personTeacher.urlVideoFormat)"/>
                      <b-icon v-else class="icon icon-yout-disabled" icon="youtube" />
                    </div>
                  </div>
                  <template slot="next" v-if="showNext(arrayListTeacherDetail.length)"
                    ><span class="material-icons next"
                      >chevron_right</span
                    ></template
                  >
                  <template slot="prev"
                    v-if="arrayListTeacherDetail.length>0"><span class="material-icons prev"
                      >chevron_left</span
                    ></template
                  >
                </carousel>
              </div> 
              </template>
            </template>
            <div class="body-header" :class="[{active:!titleTeacher}]" style="position: relative">
              <b-form inline v-if="!flagPlanTest">
                <label class="mr-sm-3">{{$t('horario.calendario.fecha')}}</label>
                <b-form-datepicker
                  style="min-width:154px"
                  :locale="lang"
                  :hide-header="true"
                  v-model="SelectBeginningDate"
                  :value-as-date="true"
                  :min ="minDate"
                  :max ="maxDate"
                  :disabled="!disabledDate"
                  :start-weekday="1"
                  
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                ></b-form-datepicker>
                <icon name="info" class="icon-info ml-3" v-b-tooltip.hover :title="$t('title.5')" />
              </b-form>
              <template v-if="flagDataFirst">
                <div class="content-buttons" v-if="titleTeacher"
                  :style= "[!flagPlanTest ? 
                  {'position': 'relative'} : 
                  {
                    'bottom': '-3.55rem',
                    'display': 'flex',
                    'justify-content': 'flex-end',
                    'position': 'absolute',
                    'right': '0px',
                    'z-index': '10',
                  }]"
                >
                  <b-button v-if="calendarEdit" variant="outline-primary"  @click="enabledCalendar" class="ml-2"><b-icon icon="pencil-square"></b-icon>{{$t('horario.next-class.edit-schedule')}}</b-button>
                  <b-button v-if="calendarEdit && !showCarousel" variant="danger" class="ml-2" @click="showModalCancelRequest">{{$t('horario.buttons.cancel-request')}}</b-button>
              
                    <b-button id="SubmitRequest"
                    v-if="!calendarEdit"
                    class="ml-2"
                    @click="showMethodAlert('SubmitRequest')"
                    variant="primary"
                    :disabled="disabledButton"
                    >{{$t('horario.calendario.button') }}</b-button>
                  <b-button v-if="showButtonCancel" variant="danger" @click="cancelChanges" class="ml-2">
                    <template v-if="!spinnerChangeCancel" >{{$t('horario.buttons.cancel-changue')}}</template>
                    <b-spinner style="color:#ffffff;"  v-else small></b-spinner>
                    </b-button>
                  
                </div>
                <div class="content-buttons carousel" v-if="!titleTeacher"
                  :style= "[!flagPlanTest ? 
                  {'position': 'relative'} : 
                  {
                    'bottom': '-3.55rem',
                    'display': 'flex',
                    'justify-content': 'flex-end',
                    'position': 'absolute',
                    'right': '0px',
                    'z-index': '10',
                  }]"
                >
                  <b-button  variant="primary" v-show="!btnSend && showAccept" @click="showModalConfirm(1)" >{{$t('horario.buttons.acept')}}</b-button>
                  <b-button variant="outline-primary" class="ml-2" v-show="!btnSend" @click="editCalendarHorario"><b-icon icon="pencil-square"></b-icon>{{$t('horario.next-class.edit-schedule')}}</b-button>
                  
                  <b-button  variant="danger" class="ml-2" v-show="!btnSend" @click="showModalCancelRequest">{{flagStateSend ? $t('horario.buttons.btn-cancel') : $t('horario.buttons.btn-refuse')}}</b-button>

                  <b-button variant="primary" class="ml-2" v-show="btnSend" @click="showModalConfirm(2)" :disabled="disabledButtonCounter">{{$t('horario.buttons.btn-send')}}</b-button>
                  <b-button variant="danger"  class="ml-2" v-show="btnSend" @click="cancelDetailTeacher" >{{$t('horario.buttons.btn-cancel')}}</b-button>
                </div>
              </template>
            
            
                    
            </div>
            <b-alert show variant="danger" class="mt-4" style="display: flex;align-items: center;" v-if="!flagAfter"><icon name="alert-2" /><p style="padding-left: 15px;margin:0px;">Porfavor Seleccionado una fecha de inicio actual</p> </b-alert>
            <template v-if="!flagPlanTest">
                <b-alert show variant="danger" class="mt-4" style="display: flex;align-items: center;" v-if="textDateChange != ''"><icon name="alert-2" /><p style="margin:0px;padding-left: 15px;">{{`${textDateChange}`}}</p> </b-alert>
            </template>
             
                
      
          </div>
          <div v-if="showLoading" class="container-loading">
            <b-spinner :label="$t('reusables.loading')" ></b-spinner>
          </div>
          <div v-else>
              <!-- CALENDARIO PARA ENVIAR O EDITAR LA SOLICITUD v-show="!flagPlanTest && arg.event.startEditable" v-if="titleTeacher"-->
              <FullCalendar class="demo-app-calendar " :options="calendarOptions"   ref="fullCalendar"  >
              <template v-slot:eventContent="arg">
                <div class="fc-event-main-frame">
                  <span  v-show="arg.event.startEditable"  @click="removeEvent(arg.event)" class="material-icons"
                    >clear</span
                  >
                  <div class="fc-event-time">{{ arg.timeText }}</div>
                  <div class="fc-event-title-container">
                    {{ arg.event.title }}
                  </div>
                </div>
              </template>
            </FullCalendar>
            <!-- CALENDARIO PARA LA CONTRAPROPUESTAS O PROFESORES QUE RESPONDIERON -->
           <!-- <FullCalendar class="demo-app-calendar " :options="calendarOptions" v-else ref="fullCalendarCounter" >
             
              <template v-slot:eventContent="arg">
                <div class="fc-event-main-frame">
                  <span  v-if="arg.event.startEditable"  @click="removeEvent(arg.event)" class="material-icons"
                    >clear</span
                  >
                  <div class="fc-event-time">{{ arg.timeText }}</div>
                  <div class="fc-event-title-container">
                    {{ arg.event.title }}
                  </div>
                </div>
              </template>
            </FullCalendar>-->
            
          </div>
       
          
        </div>
        <div v-else>
          <h4 style="text-align: center">{{$t('horario.calendario.text.2')}}</h4>
        </div>
      </b-tab>



      <!-- ENVIAR SOLICITUD DIRECTA -->
      <b-tab lazy :title="$t('horario.calendario.tabs.2')" :active="disabledTabs" id="solicitudDirecta" @click="changeActivityTab(2)" >
      <!-- INFORMACION DE CANTIDAD DE PROFESORES QUE HAS ENVIADO SOLICITUD -->

      <p class="title-carousel title mt-0 mb-5" v-if="listScheduleProposalId.length && RequestDirectEmit==0 > 0">
        {{$t('horario.calendario.text.4')}}  
        <a style="color: #508adf;cursor: pointer;" @click="showEventCarouselPrivate">{{listScheduleProposalId.length}} 
          <template v-if="listScheduleProposalId.length===1">{{$t('horario.calendario.text.7')}}</template>
          <template v-else>{{$t('horario.calendario.text.5')}}</template>
        </a></p>


      <!-- INFORMACION DE LOS PROFESORES QUE CUMPLA CON LAS CONDICIONES DEL ALUMNO , FILTRO POR NOMBRE O APELLIDO -->

      <div v-if="RequestDirectEmit==0" style="padding-bottom: 40px;">
          <h6 class="title-tab">
            {{$t('horario.calendario.text.3')}}
           <!-- <span
              class="material-icons-outlined ml-3"
              v-b-tooltip.hover
              :title="$t('title.10')"
              >info</span
            >-->
          </h6>
          <div class="header-body">
            <input type="text" :placeholder="$t('reusables.searchName')" v-model="SearchName" 
            @keyup="getSearchTeacher" 
             />
            <label style="font-size:15px" v-if="!showLoadingPrivate">
              {{totalRegisterTeacher == 0 ? $t('horario.calendario.text.8') : totalRegisterTeacher}} {{$t('horario.calendario.text.8')}}
            </label>
          </div>
        
          <div v-if="showLoadingPrivate" class="container-loading">
            <b-spinner :label="$t('reusables.loading')" ></b-spinner>
          </div>
          <div v-else-if="spinnerSearchPrivate" style="display: flex;justify-content: center;">
            <b-spinner style="width: calc(3rem - 4px); height: calc(3rem - 4px);" label="Busy"></b-spinner>
          </div>
          <div v-else>
            <div class="card card_teacher list" v-for="(item,index) in arrayTeacherPrivate" :key="`list-teacher-private-${index}`">
              <div class="card-perfil">
                  <div class="d-flex">
                    <div class="perfil">
                      <b-avatar
                        variant="light"
                        :src="item.person.photo ? item.person.photo : urlPhoto "
                        size="4.3rem"
                      ></b-avatar>
                      <b-form-rating :value="item.totalQualification" no-border readonly></b-form-rating>
                      <b-link @click="getTeacherInformationAndComments(item.id)">{{item.totalCommentary}} {{$t('horario.carousel.opinions')}}</b-link>
                    </div>
                    <div class="info">
                      <h6>{{item.person.strFullName}}</h6>
                      <p>
                        <icon name="location" />{{item.person.countryOriginDescription}}
                      </p>
                    </div>
                  </div>
              </div>
              <div class="buttons">
                <b-button variant="outline-primary" class="btn-outline" @click="getModalScheduleView(item.id,item,1)"
                  ><b-icon icon="calendar2-week"></b-icon>{{$t('horario.calendario.button-2')}}</b-button
                >
                <b-button variant="primary"  @click="getModalScheduleView(item.id,item,2)" :disabled="item.flagEnviado"  class="btn-gris justify-content-center">
                  	<template v-if="!showSpinnerSendRequest" > {{$t('horario.calendario.button')}}</template>
                    <b-spinner
                    style="width: 1rem !important; height: 1rem !important"
                    v-else
                    variant="success"
                    label="Spinning"
                    ></b-spinner></b-button>
              </div>
              
              <div @click="getModalVideo(item.urlVideoFormat)" class="video" style="background">
                <!-- <b-icon icon="play-circle"></b-icon> -->
                <div class="open-modal"></div> 
                <iframe width="560" height="315" :src="item.urlVideoFormat" :title="$t('title.4')"
                frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowfullscreen></iframe>
              </div>
            </div>
            <div class="text-center pb-4">
              <div v-if="spinnerPageDirect">
                <b-spinner label="Busy"></b-spinner>
              </div>
              <b-button v-else  v-show="arrayTeacherPrivate.length != totalRegisterTeacher " class="btn-collapse" @click="changueTextMethod" id="collapse-card"
              >Ver más</b-button>
            </div>
          </div>
    
      
      </div>

        <div v-else>
          <div class="header-calendar">
            <div class="back-step mt-0" @click="RequestDirectEmit=0; textDateChange = ''; disabledDatePrivate = false;">
              <icon name="arrow-left" />{{$t('horario.calendario.search-teacher')}}
            </div>

            <!-- PROGRAMAR HORARIO RECURRENTE -->

            <template v-if="!showCarouselTeacherPrivate">
              <!-- carrusel en tab directo -->
              <h6 class="title-tab">
                  {{ flagPlanTest ?  $t('horario.calendario.titulo-test-class') : $t('horario.calendario.titulo')}}
                <icon name="info" class="icon-info ml-3" v-b-tooltip.hover :title="$t('title.10')" />
              </h6>
              <div class="card card_teacher d-flex recurrent active">
                <div class="d-flex">
                  <div class="perfil">
                    <b-avatar
                      variant="light"
                      :src=" teacherData.person.photo ? teacherData.person.photo : urlPhoto "
                      size="65px"
                    ></b-avatar>
                    <b-form-rating :value="teacherData.totalQualification" no-border readonly></b-form-rating>
                    <b-link @click="getTeacherInformationAndComments(teacherData.id)" >{{teacherData.totalCommentary}} {{$t('horario.carousel.opinions')}}</b-link>
                  </div>
                  <div class="info">
                    <h6>{{ teacherData.person.strFullName}}</h6>
                    <p>
                      <icon name="location" />{{teacherData.person.countryOriginDescription}}
                    </p>
                  </div>
                </div>
                <div
                  class="d-flex align-items-center justify-content-between link-youtube" style="margin-top: 1px !important;"
                >
                  <b-icon v-if="teacherData.urlVideoFormat != null && teacherData.urlVideoFormat != ''" class="icon" icon="youtube"  @click="getModalVideo(teacherData.urlVideoFormat)"/>
                  <b-icon v-else class="icon icon-yout-disabled" icon="youtube" />
                </div>
              </div>
              <div class="body-header mt-5" :class="[{active:!titleTeacher}]" v-if="true">
                <div class="content-calendar" style="width:  30vw !important;" > 
                   <b-form inline v-if="!flagPlanTest">
                 
                    <label class="mr-sm-3">{{$t('horario.calendario.fecha')}}</label>
                    <b-form-datepicker
                      style="min-width:154px"
                      :locale="lang"
                      :hide-header="true"
                      v-model="SelectBeginningDate"
                      :value-as-date="false"
                      :disabled="disabledDatePrivate"
                      :min ="minDate"
                      :max ="maxDate"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                    ></b-form-datepicker>
                    <icon name="info" class="ml-3" v-b-tooltip.hover :title="$t('title.5')" />
                 
                   </b-form>
                 </div> 
                <div class="content-buttons">
                  <div v-if="flagDataSecond">
                    <b-button
                      class="btn-primary"
                      variant="primary"
                      :disabled="disabledButton"
                      @click="sendPrivateRequest"
                    >{{$t('horario.calendario.button')}}</b-button>
                  </div>
                  <!-- calendarEdit  -->
                
                </div>
              </div>
            </template>

            <!-- LISTADO DE PROFESORES QUE RESPONDIENTO LA SOLICITUD -->

            <div v-else style="margin-bottom: 20px;">
              <div :key="'div_teacher_private_'+arrayListTeacherDetail.length">
                <carousel
                  class="mb-4"
                  :mouseDrag="false"
                  :touchDrag="false"
                  :center ="false"
                  :margin = "10"
                  :nav="false"
                  :items="3"
                  :responsive="{1920:{items:4}}"
                  id="items-carousel">
                  <div @click="getDetailTeacherPrivate(item.id,`teacher-private-id-${item.id}`,item,index,item.personTeacher.person.strFullName)" :id="`teacher-private-id-${item.id}`" class="card card_teacher card_teacher_private_carousel"  v-for="(item,index) in arrayListTeacherDetail" :key="`teacher-${index}`">
                    <div class="d-flex">
                      <div class="perfil">
                        <b-avatar
                          variant="light"
                         :src=" item.personTeacher.person.photo ? item.personTeacher.person.photo : urlPhoto "
                          size="3rem"
                        ></b-avatar>
                        <b-form-rating :value="item.personTeacher.totalQualification" no-border readonly></b-form-rating>
                        <b-link @click="getTeacherInformationAndComments(item.personTeacher.id)">{{item.personTeacher.totalCommentary}} {{$t('horario.carousel.opinions')}}</b-link>
                      </div>
                      <div class="info">
                            <p style="font-weight:bold;"   :style="{color:item.color }"
                        
                        >{{item.stateProposal.name}}</p>
                        <h6 @click="getDetailTeacherPrivate(item.id,`teacher-private-id-${item.id}`,item,index,item.personTeacher.person.strFullName)">{{`${item.personTeacher.person.firstName} ${item.personTeacher.person.lastName}`}}</h6>
                        <p>
                          <icon name="location" />{{item.personTeacher.person.countryOriginDescription}}
                        </p>
                      </div>
                    </div>
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <b-icon v-if="item.personTeacher.urlVideoFormat != null && item.personTeacher.urlVideoFormat != ''" class="icon" icon="youtube"  @click="getModalVideo(item.personTeacher.urlVideoFormat)" />
                      <b-icon v-else class="icon icon-yout-disabled" icon="youtube" />
                    </div>
                  </div>
                  <template slot="next" v-if="showNext(arrayListTeacherDetail.length)"
                    ><span class="material-icons next"
                      >chevron_right</span
                    ></template
                  >
                  <template slot="prev"
                    ><span class="material-icons prev"
                      >chevron_left</span
                    ></template
                  >
                </carousel>
              </div>
              <div class="body-header" :class="[{active:!titleTeacher}]">
                <div class="content-calendar" style="width: 500px !important;">
                   <b-form inline v-if="!flagPlanTest">
                 
                    <label class="mr-sm-3">{{$t('horario.calendario.fecha')}}</label>
                  <b-form-datepicker
                    style="min-width:154px"
                    :locale="lang"
                    :hide-header="true"
                    v-model="SelectBeginningDate"
                    :value-as-date="false"
                    :disabled="disabledDatePrivate"
                    :min ="minDate"
                    :max ="maxDate"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                  ></b-form-datepicker>
                  <icon name="info" class="ml-3" v-b-tooltip.hover :title="$t('title.5')" />
                   </b-form>
                 
                 </div> 
               <!--  <div class="content-buttons carousel"  v-if="true">
                  <b-button variant="outline-primary" class="btn-outline mr-4" @click="editCalendarPrivate"><b-icon icon="pencil-square" ></b-icon>Editar Horario</b-button>
                  <b-button variant="danger" class="btn btn-danger">Cancelar</b-button>            
                </div>-->
                <div class="content-buttons carousel" v-if="flagDataSecond" >
                  <b-button  variant="primary" class="btn btn-primary" v-show="editScheduleDirect && showAccept"  @click="showModalConfirm(1)" >{{$t('horario.buttons.acept')}}</b-button>
                  <b-button variant="outline-primary" class="btn-outline ml-2" v-show="editScheduleDirect"  @click="editCalendarPrivate"><icon name="edit-pencil" />{{$t('horario.next-class.edit-schedule')}}</b-button>
                  
                  <b-button  variant="danger" class="btn btn-danger ml-2" v-show="editScheduleDirect" @click="showModalCancelRequest" >{{flagStateSend ? $t('horario.buttons.btn-cancel'): $t('horario.buttons.btn-refuse')}}</b-button>

                  <b-button variant="primary" class="btn btn-primary ml-2" v-show="!editScheduleDirect" @click="showModalConfirm(2)"  :disabled="disabledButtonCounter">{{$t('horario.buttons.btn-send')}}</b-button>
               
                  <b-button variant="danger"  class="btn btn-danger ml-2" v-show="!editScheduleDirect" @click="cancelDetailTeacherDirect"  >{{$t('horario.buttons.btn-cancel')}}</b-button>
                </div>
              </div>
            </div>
            <div style="width: 40%;" class="mt-4"  v-if="!flagPlanTest">
                <b-alert show variant="danger" style="display: flex;align-items: center;" v-if="textDateChange != ''"> <icon name="alert-2" />  <p style="padding-left: 15px;margin:0px;">{{`${textDateChange}`}}</p> </b-alert>
            </div>
          
          </div>
          <div v-if="showLoadingDirect" class="container-loading">
            <b-spinner :label="$t('reusables.loading')" ></b-spinner>
          </div>
          <div v-else>
            <FullCalendar class="demo-app-calendar" ref="fullCalendarCounterPrivateSend" :options="calendarOptions" v-if="!showCarouselTeacherPrivate"  >
              <!-- display-header para que desaparezca las opciones  v-if="arg.event.startEditable"-->
              <template v-slot:eventContent="arg">
                <div class="fc-event-main-frame">
                 
                       <span  v-show="arg.event.startEditable" @click="removeEvent(arg.event)" class="material-icons"
                      >clear</span
                    >
                   <div class="fc-event-time">{{ arg.timeText }}</div>
                  <div class="fc-event-title-container">
                    {{ arg.event.title }}
                  </div>
                </div>
              </template>
            </FullCalendar>
             <FullCalendar class="demo-app-calendar" :options="calendarOptions" v-else  ref="fullCalendarCounterPrivate"  >
            
              <template v-slot:eventContent="arg">
                <div class="fc-event-main-frame">
                  <span  v-if="arg.event.startEditable" @click="removeEvent(arg.event)" class="material-icons"
                    >clear</span
                  >
                  <div class="fc-event-time">{{ arg.timeText }}</div>
                  <div class="fc-event-title-container">
                    {{ arg.event.title }}
                  </div>
                </div>
              </template>
            </FullCalendar>
          </div>
        
        </div>
      </b-tab>
    </b-tabs>
          <b-modal
            id="modal-add-event"
            centered
            @close="closeModal"
          >
            <template #modal-header="{ close }">
              <img class="close" src="@/assets/img/close_red.png" @click="close()">
              <h5>{{$t('title.11')}}</h5>
            </template>
            <p class="d-flex align-items-center" v-if="flagPlanTest">
              <i class="material-icons-outlined mr-3">bookmark</i>
              <span>{{ $t('reusables.test-class') }}</span>
            </p>
            <p class="d-flex align-items-center">
              <i class="material-icons-outlined mr-3">class</i>
              <span>{{ flagPlanTest ? new_appointment.title : titleCourse }}</span>
            </p>
            <p class="d-flex align-items-center">
              <i class="material-icons-outlined mr-3">schedule</i>
              <span>{{this.eventCreated != null? getFormatDate( this.eventCreated.startStr, this.eventCreated.endStr, this.lang , flagPlanTest, maximoHorasCalendario ): ""}}</span>
            </p>
            <div>
              <b-alert
                show
                variant="danger"
                style="padding: 5px; font-size: 0.95rem; text-align: center"
                v-if="showAlertModal"
                >{{ message }}</b-alert
              >
            </div>
            <template #modal-footer>
              <b-button variant="danger" @click="closeModal"> {{$t('horario.buttons.cancel')}} </b-button>
              <b-button @click="saveEvent" variant="primary">
                <template v-if="!showSpinnerSave">{{$t('horario.buttons.save')}}</template>
                <b-spinner
                  style="width: 1rem !important; height: 1rem !important"
                  v-else
                  variant="success"
                  label="Spinning"
                ></b-spinner>
              </b-button>
            </template>
          </b-modal>

           <b-modal
            id="modal-send-request"
            centered
            @close='$bvModal.hide("modal-send-request")'
          >
            <template #modal-header="{ close }">
              <img class="close" src="@/assets/img/close_red.png" @click="close()">
            </template>
            <p>Excediste el número máximo que es {{messageSendRequest}} para enviar solicitudes directas</p>
            <template #modal-footer>
              <b-button @click='$bvModal.hide("modal-send-request")' variant="primary">Aceptar </b-button>
           
            </template>
          </b-modal>
      <!-- --------------modal-availability------------------------>

        <!--:key="`calendario-modal-shedule`"-->
    <viewSchedule :showActions="false" @getParamsChild="getParamsChildTeacher" @RequestDirect="getRequestDirectEmit($event)" ref="viewScheduleModal"  @value="getShowModalPersonVideo($event)"  @listenTeacherInfoComments="getTeacherInformationAndComments" @getListScheduleTeacherModal="getListScheduleTeacher(teacherDirectId)" :pteacherDirectId="teacherDirectId" :pteacherData="teacherData" />
  <!-- --------------fin de modal-availability------------------------>
  <!-- MODAL CANCEL REQUEST-->
  <modalCancelRequest @updateSchedule="getUpdateListHours" ref="refCancelRequest" :id="numSave" :group-schedule-proposal-id="groupScheduleProposalId" :teacher="nameTeacher" :person-teacher-id="teacherId" :table-id="childId" :type="typeCancelRequest" :flagStateProposal ="flagStateProposal" @showCarouselPrevModel="showCarouselPrev"/>

  <!-- MODAL CONFIRM MASIVA --> 
  <modalConfirm ref="refConfirm" @updateSchedule="getUpdateListHours" :id="childId" :group-id="GroupId"  :type="typeConfirm" :typeResponseEvent="typeResponseEvent" :messageValidate="messageValidate"/>

   <!-- MODAL CONFIRM PRIVATE -->
    <modalConfirmPrivate ref="refConfirmPrivate" @updateSchedulePrivate="getUpdateListHoursPrivate"  />
    <!-- MODAL VIDEO PERSONAL -->
    <videoPerson @valueClose="getShowModalPerson= $event" :urlVideo="urlVideo"/>

    <modalTeacher :teacherInformation="teacherInformation" :flagEdit="true" @open-window-recommend='ShowModalRecomend()'/>
    <modalScoreTeacher ref="modalScore" @close-window-recommend='handleEvent()'/>
    <modalExpiryReminder ref="modalExpiry"/>

    <!-- MODAL MENSAJE VALIDACIÖN DE SOLICITUD -->
    <modalValidateProposal ref="refValidProposal" :typeResponseEvent="typeResponseEvent" :messageValidate="messageValidate" :flagTeacher="false"/>
  </div>
</template>
<script>
import viewSchedule from "@/components/modals/view-schedule";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { baseInstanceAxios } from "@/assets/js/axiosBase.js";
import carousel from "vue-owl-carousel";
import modalTeacher from "@/components/modals/commentary";
import modalCancelRequest from "@/components/modals/ModalCancelRequest";
import modalConfirm from "@/components/modals/ModalCofirm";
import modalConfirmPrivate from "@/components/modals/ModalConfirmPrivate";
import modalValidateProposal from "@/components/modals/modal-validate-proposal";
import videoPerson from "@/components/modals/video-person";
import * as Constants from "@/assets/js/appConstants";
import { redirectHorario, getCalendarHeaderFormat, getCalendarTitle, getFormatDate, getCalendarEventTimeFormat,getCalendarHeaderToolbar, getHoursByTimeZoneName, convertToUserTimeCalendarEvents, convertTimeCalendarEvents, ValidarMergeHorarios } from '@/assets/js/util.js';
 
import { mapState } from 'vuex';
import modalScoreTeacher from "@/components/modals/modal-score-teacher";
import modalExpiryReminder from "@/components/modals/modal-expiry-reminder";
import axios from 'axios';
 
var _ctx = "";
let eventGuid = 0;
export function createEventId() {
  return String(eventGuid++);
}


export default {
  components: {
    FullCalendar,
    carousel,
    modalTeacher,
    viewSchedule,
    modalCancelRequest,
    modalConfirm,
    modalConfirmPrivate,
    videoPerson,
    modalScoreTeacher,
    modalValidateProposal,
    modalExpiryReminder
  },
  props: ['student'],
 /* props: {
    student,
		backStep: {
			type: Function,
			default() {
				return {}
			}
		},
	},*/
  data(){

    return {
      expiryReminders: [], 
      urlPhoto: Constants.IMAGENES.PHOTO_TEACHER_DEFAULT,
      statePrivateStudent : null,
      dataStudentNotif : null,
      flagDataSecond : false,
      flagDataFirst :false,
      flagAfter:true,
      flagShowHeader: false,
      lang:localStorage.getItem('lang') || 'es',
      hourDisabled: [],
      textDateChange:"",
      flagPlanTest: false,
      daysMaxSchedule : 0,
      durationClassTest : 0,

      disabledDate:true,
      disabledDatePrivate : false,
      dateStudent: null,
      arraySchedulePrivate : [],
      minDate: null,
      maxDate : null,
      showLoadingDirect :false,
      editScheduleDirect: false,
      showAccept :false,
      showLoadingPrivate : true,
      showCarouselTeacherPrivate:false,
      listScheduleProposalId: [],
      flagResultList:false,
      showSpinnerSendRequest: false,
      teacherDirectId: 0,
      teacherData : {},
      spinnerSearchPrivate:false,
      spinnerPageDirect : false,
      urlVideo : null,
      totalRegisterTeacher: 0,
      currentPagePrivate : 1,
      arrayTeacherPrivate : [],
      SearchName:'',
      dataTeacher:{},
      tableId : 0,
      groupScheduleProposalId : 0,
      PersonTeacherId : 0,
      tabIndex:0, // posición de Tab
      showLoadingFirst : true,
      typeConfirm : Constants.CONFIRM_REQUEST.SEND,
      typeCancelRequest : Constants.CANCEL_REQUEST.CHILD,
      nameTeacher : '',
      flagStateProposal:false,
      showLoading : false,
      btnSend : false,
      arrayEditableSchedule: [],
      detailTeacherSchedule : {},
      arrayListTeacher : [],
      arrayListTeacherDetail : [],
      spinnerChangeCancel : false,
      showButtonCancel : false,
      RequestDirectEmit : 0,
      sentRequest:0, //numero de solicitudes enviadas
      monthCurrent:'', //tiempo actual
      btnOutCarousel:true, // if btn-outprimary
      countBtnCarousel:0, // contador del .btn-outprimary
      numberTeacher:0, //numero de profesores pendientes 
      API_URL: process.env.VUE_APP_API_URL,
      GroupId: 0,
      teacherAnswer: 1,
      FlagGroupRegisterSubject: false,
      totalCarousel: true,
      titleTeacher: true,
      showCarousel: false, //carousel ---------
      listCalendar: [],
      listCalendarCounterInit: [],
      items: [
        { text: "Horario", href: "/horario" },
        // { text: "Elegir profesor", href:""},
        { text: "Programar horario", active: true },
      ],
      calendarEdit:false,
      arrayCalendarInit: [],
      maximoHorasCalendario: 0,
      countCall: 1,
      numSave: 0,
      message: "",

      showSpinnerSave: false,
      showSpinner: false,
      showAlertModal: false,
      dismissSecs: 5,
      disabledTabs: true,
      dismissCountDown: 0,
      showTitleCalendar: false,
      titleCourse: "",
      flagState: false,
      SelectBeginningDate: new Date(),
      flagSendRequest : false,
      messageSendRequest : '',
      eventCreated: null,
      new_appointment: {
        title: null,
        description: null,
      },
      formatDay : '',
      calendarOptions: {
        //timeZone: 'UTC',
        //timeZone: 'America/Denver',
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin, // needed for dateClick
        ],
        eventDidMount: function (event) {
          //console.log('event',event)
          event.el.dataset.trigger = "focus";
        },
        //initialDate: new Date(),
        events: [],
        eventOverlap: false,
        themeSystem: "bootstrap",
        nowIndicator: true,
        firstDay : 1,
       //gotoDate: new Date('2018-06-01'),
        headerToolbar: getCalendarHeaderToolbar(this.flagShowHeader),
        buttonText:{
          today: this.$t('reusables.today'), 
        },
        titleFormat: function(date) {
          return getCalendarTitle(date.date, this.lang);
        },
        height: "auto",
        allDaySlot: false, 
        viewDidMount: (view) => {
          let GMT = getHoursByTimeZoneName(this.$moment, this.$store.state.user.timeZoneName);
          view.el.querySelector('.fc-timegrid-axis-frame').innerHTML = GMT;
        },
        initialView: "timeGridWeek",
        dayHeaderContent: (args) => {
          return getCalendarHeaderFormat(this.$moment, args.date, this.lang,this.formatDay);
        },
        eventTimeFormat: getCalendarEventTimeFormat(),
        initialEvents: [], //INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
        editable: true,
        scrollTimeReset:false,
        isLoading :true,
        eventColor:  Constants.CALENDAR_STATUS.CONFIRM.COLOR,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        eventResizableFromStart: false,
        select: this.handleDateSelect,
        //dateClick: this.handleEventClick,
        selectAllow: this.handleSelecAllow,
        eventChange: this.handleEvents
      
        /* eventsSet: 
            /* you can update a remote database when these fire:
            eventAdd:
            eventChange:
            eventRemove:
            */
      },
      childId : 0 ,
      teacherId : 0,
      currentEvents: [],
      selectedTime: null,
      /*optionsTime: [
        {text: 'Dia' },
        {text: 'Semana' },
        {text: 'Mes' },
      ],*/
      // headerToolbar: { center: 'timeGridWeek,dayGridMonth' },
      teacherInformation: null,
      getFormatDate:getFormatDate,
      typeResponseEvent: 0,
      messageValidate: '',
      cancelSource: null,
    };
  },
  async created() {
    this.GroupId = this.$store.state.group_id;
    this.getDataPlan()
    //  this.ValidateIsScheduleDirectTotal();
    _ctx = this.API_URL;
    let selectedTabs = '';

    if(this.student){
       if(this.student.flagNotification){
         selectedTabs = this.student.schedulesoptionsid == 1 ? 'public' : 'private'   
       }else{
         selectedTabs = this.$route.params.id ?  this.$route.params.id : 'public';
       }
    }else{
      selectedTabs = this.$route.params.id ?  this.$route.params.id : 'public';
    }

    this.disabledTabs = true;

    this.selectedSchedule = Constants.SCHEDULES_OPTIONS.SOLICITUD_MASIVA;
    await this.getCourses();

    if(selectedTabs == 'public'){
      this.disabledTabs = false;
      this.selectedSchedule = Constants.SCHEDULES_OPTIONS.SOLICITUD_MASIVA;
      this.typeCancelRequest = Constants.CANCEL_REQUEST.CHILD,
      await this.getListHoursCalendar();
      await this.getListHours();
    
      if(this.student){
        if(this.student.flagNotification){
            this.showEventCarousel();
        }
      }
       
    }else if(selectedTabs == 'private'){
      this.selectedSchedule = Constants.SCHEDULES_OPTIONS.SOLICITUD_DIRECTA;
      await this.getListTeacherPrivate(1);

      if((this.student && this.student.flagNotification) || this.$route.params.flagTabViewCarousel){
        //if(this.student.flagNotification){
            this.showEventCarouselPrivate();
       // }
      }
    }
  },
  mounted(){
    //TODO: revisar
   
    if(this.$store.state.datosSidebar.typeScheduled == Constants.TYPE_SCHEDULED.SCHEDULED){
      redirectHorario(this.$store.state.datosSidebar.typeScheduled,this,this.$store.state.is_representative);
    }
    this.checkPendingTeacherReview();
    this.loadExpiryReminders();

    //this.$refs.fullCalendar.getApi().setOption('timeZone', 'UTC');
    //this.getUrlCalendar();
  },

  computed: {
    ...mapState(['dataCalendarTeacher']),
    flagStateSend(){
        if(this.statePrivateStudent  ==  Constants.TYPE_SCHEDULE_SEND.EARRING.VALUE){
          return true
        }else{
          return false
        }
    },
  disabledButton() {
      if(this.$route.params.id == 'public'){
        if(this.flagPlanTest){
            let elmts = [];
            let arrayCalendar = [];
            let arrayCalendarInit = [];
            this.listCalendar.forEach((element) => {
              arrayCalendar.push(
                `${new Date(element.StartDate)}-${new Date(element.EndDate)}`
              );
            });
            this.arrayCalendarInit.forEach((element) => {
              arrayCalendarInit.push(
                `${new Date(element.StartDate)}-${new Date(element.EndDate)}`
              );
            });
            if (arrayCalendar.length > arrayCalendarInit.length) {
              elmts = arrayCalendar.filter(function (i) {
                return this.indexOf(i) < 0;
              }, arrayCalendarInit);
            } else {
              elmts = arrayCalendarInit.filter(function (i) {
                return this.indexOf(i) < 0;
              }, arrayCalendar);
            }
            return elmts.length == 0 ? true : false;
        }else{
        
          if(this.numSave != 0){
            let elmts = [];
            let arrayCalendar = [];
            let arrayCalendarInit = [];
            this.listCalendar.forEach((element) => {
              arrayCalendar.push(
                `${new Date(element.StartDate)}-${new Date(element.EndDate)}`
              );
            });
            this.arrayCalendarInit.forEach((element) => {
              arrayCalendarInit.push(
                `${new Date(element.StartDate)}-${new Date(element.EndDate)}`
              );
            });
            if (arrayCalendar.length > arrayCalendarInit.length) {
              elmts = arrayCalendar.filter(function (i) {
                return this.indexOf(i) < 0;
              }, arrayCalendarInit);
            } else {
              elmts = arrayCalendarInit.filter(function (i) {
                return this.indexOf(i) < 0;
              }, arrayCalendar);
            }
            return elmts.length == 0 ? true : false;
          }else{
            return false
          }
        }
     
      }else{
        if(this.numSave != 0){
          let elmts = [];
          let arrayCalendar = [];
          let arrayCalendarInit = [];
          this.listCalendar.forEach((element) => {
            arrayCalendar.push(
              `${new Date(element.StartDate)}-${new Date(element.EndDate)}`
            );
          });
          this.arrayCalendarInit.forEach((element) => {
            arrayCalendarInit.push(
              `${new Date(element.StartDate)}-${new Date(element.EndDate)}`
            );
          });
          if (arrayCalendar.length > arrayCalendarInit.length) {
            elmts = arrayCalendar.filter(function (i) {
              return this.indexOf(i) < 0;
            }, arrayCalendarInit);
          } else {
            elmts = arrayCalendarInit.filter(function (i) {
              return this.indexOf(i) < 0;
            }, arrayCalendar);
          }

         
          return elmts.length == 0 ? true : false;
        }else{
          return false
        }
      }
     
      
    },
    disabledButtonCounter() {
      if(this.listCalendarCounterInit.length>0){
          let elmts = [];
          let arrayCalendar = [];
          let arrayCalendarInit = [];

          let dataCounter = this.listCalendar.filter((currentValue)=>{
            return currentValue.request ==true;
          });
          if(dataCounter.length>0){
            dataCounter.forEach((element) => {
              arrayCalendar.push(`${new Date(element.StartDate)}-${new Date(element.EndDate)}`);
            });

            this.listCalendarCounterInit.forEach((element) => {
              arrayCalendarInit.push(`${new Date(element.StartDate)}-${new Date(element.EndDate)}`);
            });
          }


          //console.log("arrayCalendar: " + JSON.stringify(arrayCalendar)); //"[11,22,33]"
          //console.log("arrayCalendarInit" + JSON.stringify(arrayCalendarInit)); //"[11,22,33]"

          if (arrayCalendar.length > arrayCalendarInit.length) {
            elmts = arrayCalendar.filter(function (i) {
              return this.indexOf(i) < 0;
            }, arrayCalendarInit);
          } else {
            
            elmts = arrayCalendarInit.filter(function (i) {
              return this.indexOf(i) < 0;
            }, arrayCalendar); 
            
            //elmts = JSON.stringify(arrayCalendarInit) != JSON.stringify(arrayCalendar) ? [{fake : '0'}] : [];
             
          }
          return elmts.length == 0 ? true : false;
        }else{
          return false
        }
    },
    userTimeZone(){
      return this.$store.state.user.timeZoneName;
    }
  },
  watch:{

  },

  methods: {
    getShowModalPersonVideo(val){
  
        
      if(val.flag ==true){
        this.urlVideo = val.urlVideo;
        this.$bvModal.show("modal-content-video");
      } else{
        this.$bvModal.hide('modal-content-video');
      }
    },
    getInitCalendar(){
    },
    showNext(cant) {
      let w = window.innerWidth;
      if(w >= 1920) {
        return cant > 4;
      } else if(w > 1300) { 
        return cant >= 4;
      } else {
        return cant > 3;
      }
    },
    handleSelecAllow(selectInfo){
       let num = this.ObtenerRangoFecha(selectInfo.startStr,  selectInfo.endStr)
  
        if(num > 0){
          return false
        }
       if(this.flagPlanTest){
       
        let endAfterDate = selectInfo.end

        //let dataAfter = this.$moment().add(this.daysMaxSchedule-1, 'days').format("YYYY-MM-DD")
        let dateCurrent = new Date();
        let newDateCurrent = new Date(dateCurrent.setMinutes(dateCurrent.getMinutes()-this.maximoHorasCalendario*60))

        let dataAfter = this.$moment(newDateCurrent).add(this.daysMaxSchedule-1, 'days')

        let dataStar = this.$moment(selectInfo.start)
      
        let valueBefore = this.$moment(dataStar).isSameOrBefore(dataAfter);
      
        let valueAfter = this.$moment(new Date(selectInfo.start)).isAfter(new Date());
      
        let dateSelectStart =new Date(selectInfo.start)
    
       

        if(this.tabIndex == 0){
          if(this.titleTeacher){
            if(this.listCalendar.length==1){
              return false;
            }
          }else{
    
            if(this.arraySchedulePrivate.length == 1){
              return false;
            }
          }

        }else{
      
          let arraySend = this.listCalendar.filter((currentValue)=>{
            return currentValue.request 
          })
          if(arraySend.length==1){
            return false;
          }

        }
     
        let dateAfter = new Date(dateSelectStart.setMinutes(dateSelectStart.getMinutes()+this.maximoHorasCalendario*60))
      
        if(new Date(endAfterDate).getTime() <= dateAfter.getTime() && (valueBefore && valueAfter)){
          return true
        }else{
          return false
        }
      }else{

          let dateSelectStart =new Date(selectInfo.start)
          let endAfter = selectInfo.end
          
          let dateAfter = new Date(dateSelectStart.setHours(dateSelectStart.getHours()+this.maximoHorasCalendario))

          if(endAfter.getTime() <=dateAfter.getTime()){
            return true
          }else{
             return false
          }

      }
     
      
      
    },
  
    getDataPlan(){
      let data = {
        GroupId : this.GroupId 
      }
      baseInstanceAxios.get(`${this.apiURL}/resources/GroupsCoursesLessons/EntitySchedulePlanTest`,
        {
          params: data
        }).then(response => {
        
          if(response.data.entity){
               this.maximoHorasCalendario = response.data.entity.maximoHorasCalendario
               this.flagPlanTest = response.data.entity.flagPlanTest
               this.daysMaxSchedule = response.data.entity.daysMaxSchedule
            
              if(response.data.entity.flagPlanTest){
                this.SelectBeginningDate = null;
                this.flagShowHeader = true;
                this.formatDay = 'DD'
                this.maximoHorasCalendario = response.data.entity.durationClassTest/60
                this.calendarOptions.validRange = {
                  start: this.$moment().format('YYYY-MM-DD'),
                  end: this.$moment().add(this.daysMaxSchedule, 'd').format('YYYY-MM-DD'),
                };
             
              }else{
                this.flagShowHeader = false;
                this.formatDay = ''
              }
            
              this.calendarOptions.headerToolbar = getCalendarHeaderToolbar(this.flagShowHeader);
          }
        
      })
    },

    getDatosGenerales(){
    
			let json = {
				GroupsId: this.GroupId,
				PersonId: this.$store.state.user.id,
				PersonStudentId: this.$store.state.user.personStudentId,
				Page: 0,
				Size: 0,
				TypeSearch: false
			};
  
			baseInstanceAxios
				.post(`${this.apiURL}/resources/dashboard/GetDataGeneral`, json)
				.then((response) => {
        
					if(response.data != null){
						if(response.data.entity != null ){
	
							if(response.data.entity.entityGroupScheduleProposal != null){
               
								let scheduleValue = response.data.entity.entityGroupScheduleProposal.tipoHorarioProgramado;
             
                this.$store.state.datosSidebar.flagEdited = response.data.entity.entityGroupScheduleProposal.flagChangeTeacher;
              
                if(this.$store.state.datosSidebar.flagEdited){
                  if(scheduleValue == 0){
                    this.$store.state.datosSidebar.typeScheduled = Constants.TYPE_SCHEDULED.MASS_REQUEST;
									
                    if(this.$router.history.current.path != "/horario/calendario/public"){
                      this.$router.push({ name: 'horario-calendario' , params: { id: "public" }}).catch(err => {}); 
                    }
                  }else{
                    	switch (scheduleValue) {
                        case Constants.TYPE_SCHEDULED.UNPROGRAMMED:
                      
                            this.$store.state.datosSidebar.typeScheduled = Constants.TYPE_SCHEDULED.UNPROGRAMMED;

                            this.$router.push({ name: 'horario'}).catch(err => {}); 
                            
                          break;
                        case Constants.TYPE_SCHEDULED.MASS_REQUEST:
                            this.$store.state.datosSidebar.typeScheduled = Constants.TYPE_SCHEDULED.MASS_REQUEST;
                        
                            if(this.$router.history.current.path != "/horario/calendario/public"){
                                this.$router.push({ name: 'horario-calendario' , params: { id: "public" }}).catch(err => {}); 
                            }
                          
                            
                          break;
                        case Constants.TYPE_SCHEDULED.DIRECT_REQUEST:
                            this.$store.state.datosSidebar.typeScheduled = Constants.TYPE_SCHEDULED.DIRECT_REQUEST;
                            if(this.$router.history.current.path != "/horario/calendario/private"){
                                this.$router.push({ name: 'horario-calendario' , params: { id: "private" }}).catch(err => {}); 
                            }

                            
                          break;
                        case Constants.TYPE_SCHEDULED.SCHEDULED:
                    
                            this.$store.state.datosSidebar.typeScheduled = Constants.TYPE_SCHEDULED.SCHEDULED;
                            this.$router.push({ name: 'horario-calendario-clases'}).catch(err => {}); 
                            
                          break;
                      }
                  }
                }else{
                  	switch (scheduleValue) {
                      case Constants.TYPE_SCHEDULED.UNPROGRAMMED:
                    
                          this.$store.state.datosSidebar.typeScheduled = Constants.TYPE_SCHEDULED.UNPROGRAMMED;

                          this.$router.push({ name: 'horario'}).catch(err => {}); 
                          
                        break;
                      case Constants.TYPE_SCHEDULED.MASS_REQUEST:
                          this.$store.state.datosSidebar.typeScheduled = Constants.TYPE_SCHEDULED.MASS_REQUEST;
                      
                          if(this.$router.history.current.path != "/horario/calendario/public"){
                              this.$router.push({ name: 'horario-calendario' , params: { id: "public" }}).catch(err => {}); 
                          }
                        
                          
                        break;
                      case Constants.TYPE_SCHEDULED.DIRECT_REQUEST:
                          this.$store.state.datosSidebar.typeScheduled = Constants.TYPE_SCHEDULED.DIRECT_REQUEST;
                          if(this.$router.history.current.path != "/horario/calendario/private"){
                              this.$router.push({ name: 'horario-calendario' , params: { id: "private" }}).catch(err => {}); 
                          }

                          
                        break;
                      case Constants.TYPE_SCHEDULED.SCHEDULED:
                  
                          this.$store.state.datosSidebar.typeScheduled = Constants.TYPE_SCHEDULED.SCHEDULED;
                          this.$router.push({ name: 'horario-calendario-clases'}).catch(err => {}); 
                          
                        break;
                    }
                }
							

							}


						}
						
					}
         
         
				});
		},

    cancelDetailTeacherDirect(){
       
      this.editScheduleDirect = true;

      let json = {
        ID : this.childId,
        FlagPlanTest : this.flagPlanTest,
        TimeZoneName: this.$store.state.user.timeZoneName
      }

      this.showLoadingDirect = true;
      this.listCalendar = [];
      this.listCalendarCounterInit = [];
      this.calendarOptions.events = [];
      
      baseInstanceAxios
        .post(`${this.apiURL}/resources/GroupScheduleCounterProposal/ListScheduleDetailsByTeachers`,json)
        .then(response => {
          if(!this.flagPlanTest){
            this.textDateChange = response.data.entity.flagDateChanges ? this.$t('calendario.text.6') : ""
          }
          this.showAccept = response.data.entity.flagShowAccept;//typeProposalId == 49 ? true  : false
          this.dataTeacher = response.data.entity
          this.groupScheduleProposalId = response.data.entity.groupScheduleProposalId;
      
          let arrayHoursTmp = response.data.entity.groupScheduleCounterProposalDetail;
          let arrayHoursConvert = convertToUserTimeCalendarEvents(arrayHoursTmp.filter((item)=>{
                                    return item.typeOfSchedule  == Constants.TYPE_OF_SCHEDULE.COUNTERPROPOSAL_REQUEST_TIMETABLE
                                  }),this.$store.state.user.timeZoneName, this.$moment )
                                ;

        
          let arrayHours = arrayHoursTmp.filter((item)=>{
                                  return item.typeOfSchedule != Constants.TYPE_OF_SCHEDULE.COUNTERPROPOSAL_REQUEST_TIMETABLE
                         })
                         .concat(arrayHoursConvert);
          //let arrayHours = response.data.entity.groupScheduleCounterProposalDetail;


          this.SelectBeginningDate = response.data.entity.beginningDate;
          let dataList = [];
          let id = 0

          arrayHours.forEach((element) => {
          
            let colorResquest = ""; 
            let titleClass = ""
              if(Constants.TYPE_OF_SCHEDULE.SCHEDULE_REQUEST==element.typeOfSchedule || Constants.TYPE_OF_SCHEDULE.COUNTERPROPOSAL_REQUEST_TIMETABLE == element.typeOfSchedule){
              let startOfWeek = this.$moment(element.startDate).startOf('week').toDate();
              let startOfWeekCurrent = this.$moment().startOf('week').toDate();
              let diff = this.$moment(startOfWeekCurrent).diff(this.$moment(startOfWeek), 'days')
              if(diff<0){
                diff= 0
              }
              this.dateStudent  = new Date(this.$moment(element.startDate).add(diff,'d'))
              let dateInitData = this.$moment(element.startDate).add(diff,'d');
              let dateEndData = this.$moment(element.endDate).add(diff,'d')
              colorResquest = Constants.CALENDAR_STATUS.CONFIRM.COLOR; 
              titleClass = this.$t('reusables.student');
              this.arrayEditableSchedule.push(id)

              let jsonData = {
                id: createEventId(),
                title: titleClass,
                description: "",
                idx: id,
                start: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss') ,
                end: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss') ,
                color: colorResquest,
                editable: false
              };
            
              let data = {
                id: id,
                StartDate: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                EndDate: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                request : element.id != 0 ? true : false 
              };
              dataList.push(jsonData);
              this.listCalendar.push(data);
          

            }
            if(Constants.TYPE_OF_SCHEDULE.SCHEDULE_CLASSES_TEACHER==element.typeOfSchedule){
              for (let index = 0; index <= 7; index = index+7) {

                let dateInitData = this.$moment(new Date(element.startDate)).add(index,'d');
                let dateEndData = this.$moment(new Date(element.endDate)).add(index,'d')
                colorResquest = Constants.CALENDAR_STATUS.PENDIENT.COLOR; 
                titleClass =  this.$t('reusables.class-scheduled')
                if(element.flagPlanTest){
                  titleClass = this.$t('reusables.test-class');//"Clase de prueba";
                }
                
                  let jsonData = {
                    id: createEventId(),
                    title: titleClass,
                    description: "",
                    idx: id,
                    start: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss') ,
                    end: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss') ,
                    color: colorResquest,
                    editable: false
                  };
                
                  let data = {
                    id: id,
                    StartDate: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                    EndDate: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                    request : element.id != 0 ? true : false 
                  };
                  dataList.push(jsonData);
                  this.listCalendar.push(data);
              }
            
              
            }
            if(Constants.TYPE_OF_SCHEDULE.SCHEDULE_NOT_AVAILABLE==element.typeOfSchedule){
                for (let index = 0; index <= 7; index = index+7) {

                  let dateInitData = this.$moment(new Date(element.startDate)).add(index,'d');
                  let dateEndData = this.$moment(new Date(element.endDate)).add(index,'d')
                  colorResquest = Constants.CALENDAR_STATUS.UNAVAILABLE.COLOR; 
            
                  titleClass =  this.$t('reusables.unavailable')
                  
                  let jsonData = {
                    id: createEventId(),
                    title: titleClass,
                    description: "",
                    idx: id,
                    start: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss') ,
                    end: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss') ,
                    color: colorResquest,
                    editable: false
                  };
                
                  let data = {
                    id: id,
                    StartDate: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                    EndDate: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                    request : element.id != 0 ? true : false 
                  };
                  dataList.push(jsonData);
                  this.listCalendar.push(data);
                }
            
            
            }
            
            id++;
      
            //this.arrayCalendarInit.push(data)
          });
          let dataCounter = this.listCalendar.filter((currentValue)=>{
				    return currentValue.request ==true 
			     });
          this.listCalendarCounterInit=dataCounter;
          this.calendarOptions.events = dataList;
          this.calendarOptions.selectable=false;
          this.showLoadingDirect = false;

          setTimeout(() => {
            if(arrayHours.length>0){
            
                this.dateStar = new Date(this.$moment(this.dateStudent).startOf('week').toDate());
                let startOfWeek = this.$moment(this.dateStudent).startOf('week').toDate();
                
                let month = (parseInt(new Date(startOfWeek).getMonth())+1) <10 ? `0${parseInt(new Date(startOfWeek).getMonth())+1}` : parseInt(new Date(startOfWeek).getMonth())+1;
                let dayDate = parseInt(new Date(startOfWeek).getDate()) < 10  ? `0${parseInt(new Date(startOfWeek).getDate())}` : parseInt(parseInt(new Date(startOfWeek).getDate()));
                let calendarApi = this.$refs.fullCalendarCounterPrivate.getApi(); 
              
                calendarApi.gotoDate(this.$moment(startOfWeek).format('YYYY')+"-"+month+"-"+dayDate);
            }
          }, 500);
      })
      .catch(err =>{
        console.log("err : ",err)
      })
    },
    
    getListHourChild(){
        this.typeCancelRequest = Constants.CANCEL_REQUEST.CHILD,
        this.showButtonCancel = false;
        this.showCarousel = false;
        this.textDateChange = "";
        this.arrayListTeacherDetail = []
        this.titleTeacher=true;
        this.totalCarousel =false;
        this.btnSend = false;
        this.getListHours();
        this.getListHoursCalendar()
    },
 
    getColorStatus(value){
      if(value==Constants.STATUS.EARRING){
        return Constants.STATUS_COLOR.EARRING
      }else{
        if(value==Constants.STATUS.ACCEPTED){
          return Constants.STATUS_COLOR.ACCEPTED
        }else{
          if(value==Constants.STATUS.REJECTED){
          return Constants.STATUS_COLOR.REJECTED
        }else{
          if(value==Constants.STATUS.EDITED){
          return Constants.STATUS_COLOR.EDITED
          }
        }
        }
      }
    },

    editCalendarPrivate(){
       
        this.editScheduleDirect = false;
        this.calendarOptions.selectable=true;
        this.arrayEditableSchedule.forEach(id => {
            this.calendarOptions.events.forEach(element => {
              if(element.idx==id){
                element.editable = true;
              }
            });
        });

    
    },

    async changeActivityTab(typeTab){
      
      this.arraySchedulePrivate= []
      this.arrayCalendarInit = []
      this.calendarOptions.events = []
      this.textDateChange = "";
      this.flagAfter = true;
      this.typeCancelRequest = Constants.CANCEL_REQUEST.CHILD
      this.flagDataFirst = false;
      this.flagDataSecond = false;
      if(typeTab==1){
          this.showButtonCancel = false;
          this.calendarEdit = true;
        this.selectedSchedule = Constants.SCHEDULES_OPTIONS.SOLICITUD_MASIVA;
        this.$router.push({ path: '/horario/calendario/public' }).catch(err => {}); 
        this.disabledDatePrivate = false;
        this.arrayListTeacherDetail = []
        this.totalCarousel = false
        this.titleTeacher = true;
        this.getListHoursCalendar();
        await this.getCourses();
        this.getListHours();
      }else{
        
        this.disabledDatePrivate = false;
        this.SelectBeginningDate = new Date();
        this.selectedSchedule = Constants.SCHEDULES_OPTIONS.SOLICITUD_DIRECTA;
        this.$router.push({ path: '/horario/calendario/private' }).catch(err => {}); 
        this.SearchName = ''
        this.showLoadingPrivate = true;
        if( this.RequestDirectEmit==1){
           this.RequestDirectEmit = 0
        }
       
        // this.ValidateIsScheduleDirectTotal();
        this.getListTeacherPrivate(2);
      }
    },
    async ValidateIsScheduleDirectTotal(){
            let query = {
        GroupId:this.GroupId
      }
   
      await baseInstanceAxios
      .get(`${this.apiURL}/Resources/PersonsTeachers/ValidateIsScheduleDirectTotal`,{
        params: query
      })
      .then(response => {
        if(response.data){
      
          this.flagSendRequest = response.data.return;
          this.messageSendRequest = response.data.message;
        }
     
      })
      .catch(err =>{
        console.log("err : ",err)
      })
    },
    async showEventCarouselPrivate(){
     
       this.flagDataSecond = false;
        if(this.$store.state.datosSidebar.flagEdited){
         this.disabledDatePrivate = true;
        }
        else{
       this.disabledDatePrivate = false; //true;
        }
       this.RequestDirectEmit = 1;
       this.editScheduleDirect = true;
       this.showCarouselTeacherPrivate = true;
       await this.getListTeacherCarouselPrivate();
    },

    async getListTeacherCarouselPrivate(){
    

      let json = {
        listGroupScheduleProposalId:this.listScheduleProposalId
      }

      await baseInstanceAxios
      .post(`${this.apiURL}/resources/GroupScheduleCounterProposal/ListScheduleCounterByTeachersCarrusel`,json)
      .then(response => {
     
        response.data.list.forEach(element => {
            element.color = '#b7b8bd'
        });
      
        this.arrayListTeacherDetail = response.data.list

     
       /*
        if(this.arrayListTeacherDetail.length>0){
          this.getDetailTeacherPrivate(this.arrayListTeacherDetail[0].id,`teacher-private-id-${this.arrayListTeacherDetail[0].id}`,this.arrayListTeacherDetail[0],0)
        }*/

        if(this.arrayListTeacherDetail.length>0){
          if(this.student){
            if(this.student.flagNotification){
              this.getDetailTeacherPrivate(this.student.groupScheduleCounterProposalId,`teacher-private-id-${this.student.groupScheduleCounterProposalId}`,this.arrayListTeacherDetail[0],0,this.arrayListTeacherDetail[0].personTeacher.person.strFullName)
 
              this.student.flagNotification = false;
            }else{
              this.getDetailTeacherPrivate(this.arrayListTeacherDetail[0].id,`teacher-private-id-${this.arrayListTeacherDetail[0].id}`,this.arrayListTeacherDetail[0],0,this.arrayListTeacherDetail[0].personTeacher.person.strFullName)
            }
          }else{
           this.getDetailTeacherPrivate(this.arrayListTeacherDetail[0].id,`teacher-private-id-${this.arrayListTeacherDetail[0].id}`,this.arrayListTeacherDetail[0],0,this.arrayListTeacherDetail[0].personTeacher.person.strFullName)
          }

         
        }

      })
      .catch(err =>{
        console.log("err : ",err)
      })
    },
    getDetailTeacherPrivate(id,divId,item,index,nameTeacher){
      
      this.nameTeacher = nameTeacher;
 
      this.flagDataSecond = false;
      this.editScheduleDirect = true;
      this.calendarOptions.selectable=false;
      this.typeCancelRequest = Constants.CANCEL_REQUEST.CHILD_TEACHER
      this.childId = id
       let json = {
        ID : id,
        FlagPlanTest : this.flagPlanTest,
        TimeZoneName: this.$store.state.user.timeZoneName
      }
      this.showLoadingDirect = true;
      this.listCalendar = [];
      this.listCalendarCounterInit = [];
      this.calendarOptions.events = [];
      
      baseInstanceAxios
        .post(`${this.apiURL}/resources/GroupScheduleCounterProposal/ListScheduleDetailsByTeachers`,json)
        .then(response => {

        this.statePrivateStudent = response.data.entity.stateProposal.value;
        this.flagStateProposal = response.data.entity.flagStateProposal;
        /* if(this.flagStateSend){
            this.typeCancelRequest = Constants.CANCEL_REQUEST.CHILD
          }else{
            this.typeCancelRequest = Constants.CANCEL_REQUEST.CHILD_TEACHER
          }*/

        if(!this.flagPlanTest){
          this.textDateChange = response.data.entity.flagDateChanges ? this.$t('calendario.text.6') : ""
        }
           
          this.showAccept = response.data.entity.flagShowAccept;//.typeProposalId == 49 ? true  : false; //TODO: Quitar hardcodeo
          this.dataTeacher = response.data.entity;
          this.groupScheduleProposalId = response.data.entity.groupScheduleProposalId;
    
          let arrayHoursTmp = response.data.entity.groupScheduleCounterProposalDetail;
          let arrayHoursConvert = convertToUserTimeCalendarEvents(arrayHoursTmp.filter((item)=>{
                                    return item.typeOfSchedule  == Constants.TYPE_OF_SCHEDULE.COUNTERPROPOSAL_REQUEST_TIMETABLE
                                  }),this.$store.state.user.timeZoneName, this.$moment )
                                ;

        
          let arrayHours = arrayHoursTmp.filter((item)=>{
                                  return item.typeOfSchedule != Constants.TYPE_OF_SCHEDULE.COUNTERPROPOSAL_REQUEST_TIMETABLE
                         })
                         .concat(arrayHoursConvert);
        //let arrayHours = response.data.entity.groupScheduleCounterProposalDetail;
        



        this.SelectBeginningDate = response.data.entity.beginningDate;
        this.getDateMinMax(new Date());
        let dataList = [];
        let id = 0

        arrayHours.forEach((element) => {
        
          let colorResquest = ""; 
          let titleClass = ""
        
          if(Constants.TYPE_OF_SCHEDULE.SCHEDULE_REQUEST==element.typeOfSchedule || Constants.TYPE_OF_SCHEDULE.COUNTERPROPOSAL_REQUEST_TIMETABLE == element.typeOfSchedule){
            let startOfWeek = this.$moment(element.startDate).startOf('week').toDate();
            let startOfWeekCurrent = this.$moment().startOf('week').toDate();
            let diff = this.$moment(startOfWeekCurrent).diff(this.$moment(startOfWeek), 'days')
            if(diff<0){
              diff= 0
            }
            this.dateStudent  = new Date(this.$moment(element.startDate).add(diff,'d'))
            let dateInitData = this.$moment(element.startDate).add(diff,'d');
            let dateEndData = this.$moment(element.endDate).add(diff,'d')
            colorResquest = Constants.CALENDAR_STATUS.CONFIRM.COLOR; 
            titleClass = this.$t('reusables.student');
            this.arrayEditableSchedule.push(id)

            let jsonData = {
              id: createEventId(),
              title: titleClass,
              description: "",
              idx: id,
              start: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss') ,
              end: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss') ,
              color: colorResquest,
              editable: false
            };
          
            let data = {
              id: id,
              StartDate: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
              EndDate: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
              request : element.id != 0 ? true : false 
            };
            dataList.push(jsonData);
            this.listCalendar.push(data);
         

          }
          if(Constants.TYPE_OF_SCHEDULE.SCHEDULE_CLASSES_TEACHER==element.typeOfSchedule){
            for (let index = 0; index <= 7; index = index+7) {

              let dateInitData = this.$moment(new Date(element.startDate)).add(index,'d');
              let dateEndData = this.$moment(new Date(element.endDate)).add(index,'d')
              colorResquest = Constants.CALENDAR_STATUS.PENDIENT.COLOR; 
              titleClass =  this.$t('reusables.class-scheduled')
              if(element.flagPlanTest){
                titleClass = this.$t('reusables.test-class');//"Clase de prueba";
              }
              
                let jsonData = {
                  id: createEventId(),
                  title: titleClass,
                  description: "",
                  idx: id,
                  start: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss') ,
                  end: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss') ,
                  color: colorResquest,
                  editable: false
                };
              
                let data = {
                  id: id,
                  StartDate: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                  EndDate: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                  request : element.id != 0 ? true : false 
                };
                dataList.push(jsonData);
                this.listCalendar.push(data);
            }
           
             
          }
          if(Constants.TYPE_OF_SCHEDULE.SCHEDULE_NOT_AVAILABLE==element.typeOfSchedule){
              for (let index = 0; index <= 7; index = index+7) {

                let dateInitData = this.$moment(new Date(element.startDate)).add(index,'d');
                let dateEndData = this.$moment(new Date(element.endDate)).add(index,'d')
                colorResquest = Constants.CALENDAR_STATUS.UNAVAILABLE.COLOR; 
          
                titleClass =  this.$t('reusables.unavailable')
                
                let jsonData = {
                  id: createEventId(),
                  title: titleClass,
                  description: "",
                  idx: id,
                  start: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss') ,
                  //end: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss') ,
                  end: this.$moment(dateEndData).format("HH:mm") == '23:59' ? this.$moment(dateEndData).add(1, 'minutes').format("YYYY-MM-DDTHH:mm:ss") : this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                
                  color: colorResquest,
                  editable: false
                };
              
                let data = {
                  id: id,
                  StartDate: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                  EndDate: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                  request : element.id != 0 ? true : false 
                };
                dataList.push(jsonData);
                this.listCalendar.push(data);
              }
           

           
          }

     
           id++;
        
          });
          const dataCounter = this.listCalendar.filter((currentValue)=>{
				    return currentValue.request ==true 
			     });
          //this.listCalendarCounterInit=dataCounter;          
          dataCounter.forEach(element => {
            this.listCalendarCounterInit.push( {a : element.id, EndDate: element.EndDate, StartDate: element.StartDate });
          });

        this.calendarOptions.events = dataList;

         this.calendarOptions.selectable=false;
        
        this.arrayListTeacherDetail.forEach(element => {
          element.color = '#b7b8bd'
        });
        if(this.arrayListTeacherDetail[index]){
          this.arrayListTeacherDetail[index].color = this.getColorStatus(item.stateProposal.value)
        }
        this.listItemExchanges = document.querySelectorAll('.card_teacher_private_carousel')

        for (let index = 0; index < this.listItemExchanges.length; index++) {
        
          this.listItemExchanges[index].classList.remove('active');
        }
        document.getElementById(divId).classList.add('active') 
        this.showLoadingDirect = false;
      
        this.flagDataSecond = true;
        setTimeout(() => {
          if(arrayHours.length>0){
              let startOfWeek = this.$moment(this.dateStudent).startOf('week').toDate();
              
              let month = (parseInt(new Date(startOfWeek).getMonth())+1) <10 ? `0${parseInt(new Date(startOfWeek).getMonth())+1}` : parseInt(new Date(startOfWeek).getMonth())+1;
              let dayDate = parseInt(new Date(startOfWeek).getDate()) < 10  ? `0${parseInt(new Date(startOfWeek).getDate())}` : parseInt(parseInt(new Date(startOfWeek).getDate()));
              let calendarApi = this.$refs.fullCalendarCounterPrivate.getApi(); 
            
              calendarApi.gotoDate(this.$moment(startOfWeek).format('YYYY')+"-"+month+"-"+dayDate);
          }
      }, 500);
      })
      .catch(err =>{
        console.log("err : ",err)
      })
    },

    getUpdateListHoursPrivate(){
      this.arraySchedulePrivate = [];
      this.showCarouselTeacherPrivate = false;
      this.RequestDirectEmit = 0;
      // this.ValidateIsScheduleDirectTotal();
      this.getListTeacherPrivate(2);
      this.getDatosGenerales();
    },

    sendPrivateRequest(){
      let arrayNewCalendar = [];
      let arraySend = this.listCalendar.filter((currentValue)=>{
        return currentValue.request 
      })

      let arrayNotAvailable = this.listCalendar.filter((currentValue)=>{
        return !currentValue.request 
      })

      let sumtotal = 0;
      arraySend.forEach((element) => {
        let json = {
          StartDate: element.StartDate,
          EndDate: element.EndDate,
        };
        let flagRangoFecha = this.ObtenerRangoFechaSend(element.StartDate,element.EndDate,arrayNotAvailable);
        sumtotal +=flagRangoFecha
        arrayNewCalendar.push(json);
      });

      if(this.flagPlanTest){
        this.SelectBeginningDate = arraySend[0].StartDate
      }
   
      let data = {
        Schedule: {
          PersonTeacherId : this.teacherData.id,
          SchedulesOptionsId: 2, //TODO: quitar hardcodeo
          GroupsId: this.GroupId,
          flagPlanTest : this.flagPlanTest,
          BeginningDate: this.SelectBeginningDate,
        },
        ScheduleDetail: arrayNewCalendar,
        FlagChangeTeacher: this.$store.state.datosSidebar.flagEdited,
        UserMail : this.$store.state.user.email
      };
    
      if(sumtotal == 0){
         this.$refs.refConfirmPrivate.showModal(this.teacherData.person.strFullName,data)
      }else{
          this.message = this.$t('horario.intersect-with-teacher');
          this.$bvToast.show("toast-equis-calendar-modal");
      }
     
    },
    getRequestDirectEmit(direct){
      this.RequestDirectEmit= direct,
      this.getListScheduleTeacher(this.teacherDirectId)
    },

    async getModalScheduleView(id,data,typeDirect){
      await this.ValidateIsScheduleDirectTotal();
   
      this.teacherDirectId = id;
      this.teacherData = data;
      if(typeDirect==1){
             this.$refs.viewScheduleModal.getScheduleTeacher(id,this.GroupId,this.$store.state.datosSidebar.flagEdited,data,this.flagPlanTest)
      }else{
   
        if(this.flagSendRequest){
            this.$bvModal.show('modal-send-request');
        }else{
          this.showCarouselTeacherPrivate = false;
          this.showSpinnerSendRequest = true;
          this.RequestDirectEmit= 1,
          this.getListScheduleTeacher(id);
        }
      
      }
    },
    getParamsChildTeacher(){
          this.showCarouselTeacherPrivate = false;
          this.showSpinnerSendRequest = true;
          this.RequestDirectEmit= 1;
     },
    getListScheduleTeacher(id){
      this.flagDataSecond = false;
      this.numSave = 10;
      this.arrayCalendarInit = []
      this.listCalendar= [];
      this.arrayEditableSchedule = [];
      this.calendarOptions.events = [];
      this.showLoading = true;
      let data = {
        PersonTeacherId:id,
        GroupId : this.GroupId,
        FlagChangeTeacher: this.$store.state.datosSidebar.flagEdited,
        FlagPlanTest : this.flagPlanTest,
        timeZoneName: this.$store.state.user.timeZoneName
      }

      //debugger;
      baseInstanceAxios
        .get(_ctx + "/resources/PersonsTeachers/GetByIdTeacherAvailability", 
        {
						params: data
				})
        .then((response) => {
         
          let arrayHours = response.data.entity.dtoScheduleTeachersDetails; //TODO: parsear
       
          //this.SelectBeginningDate = response.data.entity.beginningDate;
          let dataList = [];
        let id = 0

        this.hourDisabled = arrayHours.filter((valueCurrent)=>{
          return valueCurrent.typeOfSchedule == Constants.TYPE_OF_SCHEDULE.SCHEDULE_CLASSES_TEACHER || 
          valueCurrent.typeOfSchedule == Constants.TYPE_OF_SCHEDULE.SCHEDULE_NOT_AVAILABLE
        })
      
        arrayHours.forEach((element) => {
          
          let colorResquest = ""; 
          let titleClass = ""
         
          if(Constants.TYPE_OF_SCHEDULE.SCHEDULE_REQUEST==element.typeOfSchedule || Constants.TYPE_OF_SCHEDULE.COUNTERPROPOSAL_REQUEST_TIMETABLE == element.typeOfSchedule){
       
            let startOfWeek = this.$moment(element.startDate).startOf('week').toDate();
            let startOfWeekCurrent = this.$moment().startOf('week').toDate();
            let diff = this.$moment(startOfWeekCurrent).diff(this.$moment(startOfWeek), 'days')
            this.dateStudent  = new Date(this.$moment(element.startDate).add(diff,'d'))
            let dateInitData = this.$moment(element.startDate).add(diff,'d');
            let dateEndData = this.$moment(element.endDate).add(diff,'d')

            titleClass = this.$t('reusables.student');
            if(element.flagPlanTest){
              titleClass = this.$t('reusables.test-class');//"Clase de prueba";
            }
            this.arrayEditableSchedule.push(id)

            let result  = this.ObtenerRangoFechaDisable(element.startDate, element.endDate,this.hourDisabled);
         
            colorResquest = Constants.CALENDAR_STATUS.CONFIRM.COLOR; 
            if(result != 0){
              colorResquest = "#cc0000"; 
            }


            let jsonData = {
              id: createEventId(),
              title: titleClass,
              description: "",
              idx: id,
              start: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
              end: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
              color: colorResquest,
              editable: true
            };
            let data = {
              id: id,
              StartDate: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
              EndDate: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
              request : true
            };

            dataList.push(jsonData);
            this.listCalendar.push(data);

          }
          if(Constants.TYPE_OF_SCHEDULE.SCHEDULE_CLASSES_TEACHER==element.typeOfSchedule){
            for (let index = 0; index <= 7; index = index+7) {

              let dateInitData = this.$moment(new Date(element.startDate)).add(index,'d');
              let dateEndData = this.$moment(new Date(element.endDate)).add(index,'d')
              colorResquest = Constants.CALENDAR_STATUS.PENDIENT.COLOR; 
              titleClass =  this.$t('reusables.class-scheduled')
              if(element.flagPlanTest){
                titleClass = this.$t('reusables.test-class');//"Clase de prueba";
              }
             
              let jsonData = {
                id: createEventId(),
                title: titleClass,
                description: "",
                idx: id,
                start: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                end: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                color: colorResquest,
                editable: false
              };
              let data = {
                id: id,
                StartDate: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                EndDate: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                request : false
              };
              dataList.push(jsonData);
              this.arrayCalendarInit.push(data)
              this.listCalendar.push(data);
            }

          }
          if(Constants.TYPE_OF_SCHEDULE.SCHEDULE_NOT_AVAILABLE==element.typeOfSchedule){
            for (let index = 0; index <= 7; index = index+7) {
              let dateInitData = this.$moment(element.startDate).add(index,'d');
              let dateEndData = this.$moment(element.endDate).add(index,'d')
              colorResquest = Constants.CALENDAR_STATUS.UNAVAILABLE.COLOR; 
              titleClass =  this.$t('reusables.unavailable')
              let jsonData = {
                id: createEventId(),
                title: titleClass,
                description: "",
                idx: id,
                start: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                end: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                color: colorResquest,
                editable: false
              };
              let data = {
                id: id,
                StartDate: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                EndDate: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                request : false
              };
              dataList.push(jsonData);
              this.arrayCalendarInit.push(data)
              this.listCalendar.push(data);

            }
          }

           id++;

          });
          
          if(this.$store.state.datosSidebar.flagEdited){
             this.disabledDatePrivate =true; 
          }
          this.calendarOptions.events = dataList;

          this.calendarOptions.selectable=true;
         
          this.showSpinnerSendRequest = false;
          this.showLoading = false;
          this.getDateMinMax(new Date());
           this.flagDataSecond = true;

          setTimeout(() => {
           
              if(this.arrayEditableSchedule.length>0){

                  let startOfWeek = this.$moment(this.dateStudent).startOf('week').toDate();
                  
                  let month = (parseInt(new Date(startOfWeek).getMonth())+1) <10 ? `0${parseInt(new Date(startOfWeek).getMonth())+1}` : parseInt(new Date(startOfWeek).getMonth())+1;
                  let dayDate = parseInt(new Date(startOfWeek).getDate()) < 10  ? `0${parseInt(new Date(startOfWeek).getDate())}` : parseInt(parseInt(new Date(startOfWeek).getDate()));
                  let calendarApi = this.$refs.fullCalendarCounterPrivateSend.getApi(); 
                
                  calendarApi.gotoDate(this.$moment(startOfWeek).format('YYYY')+"-"+month+"-"+dayDate);
            
                
              }
          }, 500);
        
      })
      .catch(err =>{
        console.log("err : ",err)
      })
    },

    getModalVideo(url){
      this.urlVideo = url;
      this.$bvModal.show('modal-content-video')
    },

    async getListTeacherPrivate(type){
          // console.log(this.SearchName);
        if(type==2){
            this.currentPagePrivate = 1;
        }
      	let data = {
          StudentID : this.GroupId,
          Filter : this.SearchName,
          FlagChangeTeacher:this.$store.state.datosSidebar.flagEdited,
          Page : this.currentPagePrivate,
          Size : 4,
          FlagLanguage: this.lang == 'es' ? true : false,
    		}

        if(this.cancelSource){
          this.cancelSource.cancel('Start new search, stop active search');
        }

        this.cancelSource = axios.CancelToken.source();

        await baseInstanceAxios.get(`${this.apiURL}/resources/PersonsTeachers/ListByTeachersSchedules`,
          {
            cancelToken: this.cancelSource.token,
            params: data
          }).then(response => {            
            if(response.data.entity){
            
              this.listScheduleProposalId = response.data.entity.listGroupScheduleProposalIds
              if(type==1){
                response.data.entity.listPersonsTeachers.forEach(element => {
                  this.arrayTeacherPrivate.push(element)
                });
              }else{
                this.arrayTeacherPrivate=[]
                response.data.entity.listPersonsTeachers.forEach(element => {
                  this.arrayTeacherPrivate.push(element)
                });
              }

            
              this.totalRegisterTeacher =  response.data.rows
            }
            this.showLoadingPrivate = false;
            this.spinnerPageDirect = false;
            this.spinnerSearchPrivate = false; 
            this.cancelSource = null;
        })
    },

    getSearchTeacher(){
      
      this.spinnerSearchPrivate = true;
      this.currentPagePrivate=1;
      this.getListTeacherPrivate(2)
    },

    changueTextMethod(){
			/*let b = document.getElementById("collapse-card");

			if(b.classList.contains('collapsed')){
				b.innerText  ="Ver menos"
			}else{
				b.innerText  ="Ver más"
			}*/
      this.spinnerPageDirect = true;
      this.currentPagePrivate++;
      this.getListTeacherPrivate(1)
		},

    removeEvent(event) {
   
        if(event.startEditable || event.startEditable == undefined){
          if(this.tabIndex==0){
            if(!this.titleTeacher){
             
              this.arraySchedulePrivate = this.arraySchedulePrivate.filter(function (e) {
              return (
                  new Date(e.StartDate).getTime() !=
                    new Date(event.startStr).getTime() &&
                  new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
                );
              });
            }
          }else{
            
             this.arraySchedulePrivate = this.arraySchedulePrivate.filter(function (e) {
              return (
                  new Date(e.StartDate).getTime() !=
                    new Date(event.startStr).getTime() &&
                  new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
                );
              });
          }
          this.listCalendar = this.listCalendar.filter(function (e) {
            return (
              new Date(e.StartDate).getTime() !=
                new Date(event.startStr).getTime() &&
              new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
            );
          });
          this.calendarOptions.events = this.calendarOptions.events.filter(
            function (e) {
              return (
                new Date(e.start).getTime() != new Date(event.startStr).getTime() &&
                new Date(e.end).getTime() != new Date(event.endStr).getTime()
              );
            }
          );
      
          event.remove();
        }

        if(this.calendarOptions.events.length != this.listCalendar.length){
          alert("Error")
        }
 


    },

    async cancelChanges(){
      this.spinnerChangeCancel = true;
     
      let json = {
        Schedule: {
          Id: this.GroupId,
          SchedulesOptionsId:parseInt(this.selectedSchedule),
          
        },
        FlagChangeTeacher: this.$store.state.datosSidebar.flagEdited,
        TimeZoneName: this.$store.state.user.timeZoneName
      };

      await baseInstanceAxios
        .post(`${this.apiURL}/resources/GroupsCoursesLessons/ListSchedule`, json)
        .then((response) => {
         
           this.listCalendar = [];
          if (response.data) {
            if (response.data.entity) {
              this.SelectBeginningDate = response.data.entity.schedule.beginningDate
              this.numSave = response.data.entity.schedule.id;

              let arrayHoursTmp = response.data.entity.scheduleDetail;
              let arrayHours = convertToUserTimeCalendarEvents(arrayHoursTmp,this.$store.state.user.timeZoneName, this.$moment );
              //let arrayHours = response.data.entity.scheduleDetail;
                 

              this.arrayListTeacher = response.data.entity.listTeachers
              let colorEvent = ''
              let dataList = [];
              this.disabledDate = false;
              arrayHours.forEach((element) => {
            
                 let startOfWeek = this.$moment(element.startDate).startOf('week').toDate();
                let startOfWeekCurrent = this.$moment().startOf('week').toDate();
                let diff = this.$moment(startOfWeekCurrent).diff(this.$moment(startOfWeek), 'days')
                let dateInitData = this.$moment(element.startDate).add(diff,'d');
                let dateEndData = this.$moment(element.endDate).add(diff,'d')
                switch (element.stateClass.value) {
                  case "1":
                      colorEvent =  Constants.CALENDAR_STATUS.COMPLETED.COLOR;
                    break;
                
                  case "2":
                      colorEvent =  Constants.CALENDAR_STATUS.CANCELED_TEACHER.COLOR;
                    break;
                  case "3":
                      colorEvent =  Constants.CALENDAR_STATUS.CANCELED_STUDENT.COLOR;
                    break;
                  case "4":
                      colorEvent =  Constants.CALENDAR_STATUS.PENDIENT.COLOR;
                    break;
                  case "5":
                      colorEvent =  Constants.CALENDAR_STATUS.CONFIRM.COLOR;
                    break;
                }
                
                let jsonData = {
                  id: createEventId(),
                  title: this.titleCourse,
                  description: "",
                  idx: element.id,
                  start: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss') ,
                  end: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss') ,
                  color: colorEvent,
                  //editable:  this.arrayListTeacher.length>0 ? false : this.$store.state.datosSidebar.flagEdited 
                   editable: this.numSave == 0 ? true : false
                };
             
                let data = {
                  id: element.id,
                   StartDate: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                  EndDate: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                };
                dataList.push(jsonData);
              
                this.listCalendar.push(data);
              });
              this.calendarOptions.events = dataList;
              setTimeout(() => {
                if(arrayHours.length>0){

                   let d = new Date(arrayHours[0].startDatet);
                    let startOfWeek = this.$moment(d).startOf('week').toDate();
                  
                    let month = (parseInt(new Date(startOfWeek).getMonth())+1) <10 ? `0${parseInt(new Date(startOfWeek).getMonth())+1}` : parseInt(new Date(startOfWeek).getMonth())+1;
                    let dayDate = parseInt(new Date(startOfWeek).getDate()) < 10  ? `0${parseInt(new Date(startOfWeek).getDate())}` : parseInt(parseInt(new Date(startOfWeek).getDate()));
                    let calendarApi = this.$refs.fullCalendar.getApi(); 
                  
                    calendarApi.gotoDate(this.$moment(startOfWeek).format('YYYY')+"-"+month+"-"+dayDate);
                    //this.$refs.fullCalendar.getApi().setOption('timeZone', 'UTC');
                }
              }, 500);
            }
            
          }
          this.showButtonCancel = false;
          this.spinnerChangeCancel = false;
     
          this.calendarOptions.selectable=false;
          this.calendarEdit = true;
          this.getDateMinMax(new Date());
          this.message = this.$t('calendario.text.5')
          this.$bvToast.show("toast-check-calendar");
        });
    },

    getUpdateListHours(){
       if(this.flagResultList){
         if(this.tabIndex == 1){
         this.showEventCarouselPrivate();
         }else{
         this.showEventCarousel();
         }

       }else{
           if(this.tabIndex == 1){
           this.getUpdateListHoursPrivate();
           }
           this.getDatosGenerales();
           this.getListHourChild();
       }
       this.flagResultList = false;
    },

    async getListHoursCalendar() {
     
      this.flagDataFirst = false;
      this.showLoading = true;
      this.listCalendar = [];

      let json = {
        Schedule: {
          Id: this.GroupId,
          SchedulesOptionsId:parseInt(this.selectedSchedule),
          
        },
        FlagChangeTeacher: this.$store.state.datosSidebar.flagEdited,
        TimeZoneName: this.$store.state.user.timeZoneName
      };
     
      await baseInstanceAxios
        .post(
          `${this.apiURL}/resources/GroupsCoursesLessons/ListSchedule`,
          json
        )
        .then((response) => {
         
          if (this.countCall == 1) {
            this.arrayCalendarInit = [];
          }

          if (response.data) {
        
            if (response.data.entity) {
             
              this.SelectBeginningDate = response.data.entity.schedule.id == 0 ? new Date() : response.data.entity.schedule.beginningDate  ;
           
           
              this.numSave = response.data.entity.schedule.id;
              this.flagState = response.data.entity.schedule.stateId == 0 ? false : true;
              this.numberTeacher =  response.data.entity.listTeachers.length;
              this.arrayListTeacher = response.data.entity.listTeachers
              if(this.arrayListTeacher.length>0){
                this.disabledDate = false;
              }
              this.showTotalCarousel();


              let arrayHoursTmp = response.data.entity.scheduleDetail;
              let arrayHours = convertToUserTimeCalendarEvents(arrayHoursTmp,this.$store.state.user.timeZoneName, this.$moment );
             //let arrayHours = response.data.entity.scheduleDetail;
             
            
              arrayHours.forEach((element) => {
             
                let startOfWeek = this.$moment(element.startDate).startOf('week').toDate();
                let startOfWeekCurrent = this.$moment().startOf('week').toDate();
                let diff = this.$moment(startOfWeekCurrent).diff(this.$moment(startOfWeek), 'days')
                let dateInitData = this.$moment(element.startDate).add(diff,'d');
                let dateEndData = this.$moment(element.endDate).add(diff,'d')
                this.disabledDate = false;
                let data = {
                  id: element.id,
                  StartDate: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                  EndDate: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                  editable: this.numSave == 0 ? true : false
                };
                if (this.countCall == 1) {
                  this.arrayCalendarInit.push(data);
                }

                this.listCalendar.push(data);
              });
            }
          }
      
          if(this.$store.state.datosSidebar.flagEdited){
            this.disabledDate = false; 
            this.SelectBeginningDate = new Date();
          }

       
          if (!this.flagState) {
            this.showTitleCalendar = true;
            //this.calendarOptions.editable = true
            this.calendarOptions.selectable = true
            
            this.calendarEdit = false
          } else {
            this.calendarEdit = true
            //this.calendarOptions.editable = true
            this.calendarOptions.selectable = false
            this.showTitleCalendar = false;
          }
          this.countCall++;
          this.showLoading = false;
          this.getDateMinMax(new Date());
        
           this.flagDataFirst = true;
        });
    },

    async getListHours(){
          this.calendarOptions.events = [];
          let json = {
            Schedule: {
              Id: this.GroupId,
              SchedulesOptionsId:parseInt(this.selectedSchedule),
              
            },
            FlagChangeTeacher: this.$store.state.datosSidebar.flagEdited,
            TimeZoneName: this.$store.state.user.timeZoneName
          };
      
          await baseInstanceAxios
            .post(`${this.apiURL}/resources/GroupsCoursesLessons/ListSchedule`, json)
            .then((response) => {
          
              if (response.data) {
      
                if (response.data.entity) {
              
                  this.numSave = response.data.entity.schedule.id;

                  let arrayHoursTmp = response.data.entity.scheduleDetail;
                  let arrayHours = convertToUserTimeCalendarEvents(arrayHoursTmp,this.$store.state.user.timeZoneName, this.$moment );
                  //let arrayHours = response.data.entity.scheduleDetail;
                  
                  let colorEvent = "";
                  let dataList = [];
                  this.arrayListTeacher = response.data.entity.listTeachers
                  let arrayCalendar = []
                 
               
                  arrayHours.forEach((element) => {
                   
                      switch (element.stateClass.value) {
                        case "1":
                            colorEvent =  Constants.CALENDAR_STATUS.COMPLETED.COLOR;
                          break;
                        case "2":
                            colorEvent =  Constants.CALENDAR_STATUS.CANCELED_TEACHER.COLOR;
                          break;
                        case "3":
                            colorEvent =  Constants.CALENDAR_STATUS.CANCELED_STUDENT.COLOR;
                          break;
                        case "4":
                            colorEvent =  Constants.CALENDAR_STATUS.PENDIENT.COLOR;
                          break;
                        case "5":
                            colorEvent =  Constants.CALENDAR_STATUS.CONFIRM.COLOR;
                          break;
                      }
                      let startOfWeek = this.$moment(element.startDate).startOf('week').toDate();
                      let startOfWeekCurrent = this.$moment().startOf('week').toDate();
                    
                      let diff = this.$moment(startOfWeekCurrent).diff(this.$moment(startOfWeek), 'days')
                   
                      let dateInitData = this.$moment(element.startDate).add(diff,'d');
                      let dateEndData = this.$moment(element.endDate).add(diff,'d')
                      let jsonData = {
                        id: createEventId(),
                        title: this.titleCourse,
                        description: "",
                        idx: element.id,
                        start: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss') ,
                        end: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss') ,
                        color: colorEvent,
                        //editable:  this.arrayListTeacher.length>0 ? false : this.$store.state.datosSidebar.flagEdited   
                        editable: this.numSave == 0 ? true : false
                      };
                  
                      dataList.push(jsonData);
                      arrayCalendar.push(jsonData)
                  });
                  this.calendarOptions.events = dataList;
                  
                  setTimeout(() => {
                    if(arrayCalendar.length>0){
                
                        let d = new Date(arrayCalendar[0].start);
                        let startOfWeek = this.$moment(d).startOf('week').toDate();
                     
                        let month = (parseInt(new Date(startOfWeek).getMonth())+1) <10 ? `0${parseInt(new Date(startOfWeek).getMonth())+1}` : parseInt(new Date(startOfWeek).getMonth())+1;
                        let dayDate = parseInt(new Date(startOfWeek).getDate()) < 10  ? `0${parseInt(new Date(startOfWeek).getDate())}` : parseInt(parseInt(new Date(startOfWeek).getDate()));
                        let calendarApi = this.$refs.fullCalendar.getApi(); 
                      
                        calendarApi.gotoDate(this.$moment(startOfWeek).format('YYYY')+"-"+month+"-"+dayDate);
                    }
                  }, 500);

                
                }
              }
            });
    },
  
    cancelDetailTeacher(){
      this.showLoading = true;
      this.btnSend = false;
      this.btnOutCarousel = true;
      let json = {
        Id: this.childId,
        PersonTeacherId:this.teacherId,
        TimeZoneName: this.$store.state.user.timeZoneName
      }
      this.arraySchedulePrivate = [];
      this.listCalendar = [];
      this.listCalendarCounterInit = [];
      this.calendarOptions.events = [];
      
      baseInstanceAxios
      .post(`${this.apiURL}/resources/GroupScheduleCounterProposal/ListScheduleCounterDetailsByTeachers`,json)
      .then(response => {
      
        if(!this.flagPlanTest){
          this.textDateChange = response.data.entity.flagDateChanges ? this.$t('calendario.text.6') : ""
        }

        this.statePrivateStudent = response.data.entity.stateProposal == null  ? Constants.TYPE_SCHEDULE_SEND.EARRING.VALUE :  response.data.entity.stateProposal.value

        let arrayHoursTmp = response.data.entity.groupScheduleCounterProposalDetail;
        let arrayHoursConvert = convertToUserTimeCalendarEvents(arrayHoursTmp.filter((item)=>{
                                  return item.typeOfSchedule != Constants.TYPE_OF_SCHEDULE.SCHEDULE_NOT_AVAILABLE
                                }),this.$store.state.user.timeZoneName, this.$moment )
                              ;

      
        let arrayHours = arrayHoursTmp.filter((item)=>{
                                return item.typeOfSchedule == Constants.TYPE_OF_SCHEDULE.SCHEDULE_NOT_AVAILABLE
                        })
                        .concat(arrayHoursConvert);

        //let arrayHours = response.data.entity.groupScheduleCounterProposalDetail;


        this.SelectBeginningDate = response.data.entity.beginningDate;
        let dataList = [];

         let id = 0
        arrayHours.forEach((element) => {

          let colorResquest = ""; 
          let titleClass = ""
        
          if(Constants.TYPE_OF_SCHEDULE.SCHEDULE_REQUEST==element.typeOfSchedule || Constants.TYPE_OF_SCHEDULE.COUNTERPROPOSAL_REQUEST_TIMETABLE == element.typeOfSchedule){
            let startOfWeek = this.$moment(element.startDate).startOf('week').toDate();
            let startOfWeekCurrent = this.$moment().startOf('week').toDate();
            let diff = this.$moment(startOfWeekCurrent).diff(this.$moment(startOfWeek), 'days')
            this.dateStudent = new Date(this.$moment(element.startDate).add(diff,'d'))
            let dateInitData = this.$moment(element.startDate).add(diff,'d');
            let dateEndData = this.$moment(element.endDate).add(diff,'d')

            colorResquest = Constants.CALENDAR_STATUS.CONFIRM.COLOR; 
            titleClass = this.$t('reusables.student');
            this.arrayEditableSchedule.push(id)
             let jsonData = {
                id: createEventId(),
                title: titleClass,
                description: "",
                idx: id,
                start: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                end: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                color: colorResquest,
                editable: false
              };
              let data = {
                id: id,
                StartDate: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                EndDate: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                request : element.id != 0 ? true : false 
              };
              this.arraySchedulePrivate.push(data)
              dataList.push(jsonData);
              this.listCalendar.push(data);

          }
         
          if(Constants.TYPE_OF_SCHEDULE.SCHEDULE_CLASSES_TEACHER==element.typeOfSchedule){
            for (let index = 0; index <= 7; index = index+7) {

              let dateInitData = this.$moment(new Date(element.startDate)).add(index,'d');
              let dateEndData = this.$moment(new Date(element.endDate)).add(index,'d')
              colorResquest = Constants.CALENDAR_STATUS.PENDIENT.COLOR; 
               titleClass =  this.$t('reusables.class-scheduled')
              if(element.flagPlanTest){
                titleClass = this.$t('reusables.test-class');//"Clase de prueba";
              }
             
              let jsonData = {
                id: createEventId(),
                title: titleClass,
                description: "",
                idx: id,
                start: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                end: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                color: colorResquest,
                editable: false
              };
              let data = {
                id: id,
                StartDate: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                EndDate: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                request : element.id != 0 ? true : false 
              };
              dataList.push(jsonData);
              this.listCalendar.push(data);
            }


             
          }
          if(Constants.TYPE_OF_SCHEDULE.SCHEDULE_NOT_AVAILABLE==element.typeOfSchedule){
              for (let index = 0; index <= 7; index = index+7) {

              let dateInitData = this.$moment(new Date(element.startDate)).add(index,'d');
              let dateEndData = this.$moment(new Date(element.endDate)).add(index,'d')
              colorResquest = Constants.CALENDAR_STATUS.UNAVAILABLE.COLOR; 
              titleClass =  this.$t('reusables.unavailable')
             
              let jsonData = {
                id: createEventId(),
                title: titleClass,
                description: "",
                idx: id,
                start: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                end: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                color: colorResquest,
                editable: false
              };
              let data = {
                id: id,
                StartDate: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                EndDate: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                request : element.id != 0 ? true : false 
              };
              dataList.push(jsonData);
              this.listCalendar.push(data);
            }
           
          }
           id++;
          
        });
        let dataCounter = this.listCalendar.filter((currentValue)=>{
				   return currentValue.request ==true 
			  });
        this.listCalendarCounterInit=dataCounter;
        this.calendarOptions.events = dataList;

         this.calendarOptions.selectable=false;

         this.showLoading = false;

         setTimeout(() => {
          if(arrayHours.length>0){
          
               let d = new Date(this.dateStudent);
              let startOfWeek = this.$moment(d).startOf('week').toDate();
            
              let month = (parseInt(new Date(startOfWeek).getMonth())+1) <10 ? `0${parseInt(new Date(startOfWeek).getMonth())+1}` : parseInt(new Date(startOfWeek).getMonth())+1;
              let dayDate = parseInt(new Date(startOfWeek).getDate()) < 10  ? `0${parseInt(new Date(startOfWeek).getDate())}` : parseInt(parseInt(new Date(startOfWeek).getDate()));
              let calendarApi = this.$refs.fullCalendar.getApi(); 
            
              calendarApi.gotoDate(this.$moment(startOfWeek).format('YYYY')+"-"+month+"-"+dayDate);
          }
      }, 500);
      })
      .catch(err =>{
        console.log("err : ",err)
      }) 
    },


    getDetailTeacher(id,teacherId,divId,name,item,index){
      this.flagDataFirst = false;
      //getColorStatus(item.stateProposal.value)
      this.childId = id
      this.teacherId = teacherId
      this.nameTeacher = name;
      this.showLoading = true;
      this.btnSend = false;
      this.btnOutCarousel = true;

      let json = {
        Id: id,
        FlagDateChanges : this.flagPlanTest,
        TimeZoneName: this.$store.state.user.timeZoneName
      }

      baseInstanceAxios
        .post(`${this.apiURL}/resources/GroupScheduleCounterProposal/ListScheduleCounterDetailsByTeachers`,json)
        .then(response => {
     
          this.statePrivateStudent = response.data.entity.stateProposal == null ? Constants.TYPE_SCHEDULE_SEND.EARRING.VALUE :  response.data.entity.stateProposal.value
      
          if(!this.flagPlanTest){
            this.textDateChange = response.data.entity.flagDateChanges ? this.$t('calendario.text.6') : ""
          }
          this.showAccept = response.data.entity.flagShowAccept;//typeProposalId == 49 ? true  : false
          this.flagStateProposal = response.data.entity.flagStateProposal;
          this.dataTeacher = response.data.entity
          this.groupScheduleProposalId = response.data.entity.groupScheduleProposalId;

          let arrayHoursTmp = response.data.entity.groupScheduleCounterProposalDetail;
          let arrayHoursConvert = convertToUserTimeCalendarEvents(arrayHoursTmp.filter((item)=>{
                                    return item.typeOfSchedule != Constants.TYPE_OF_SCHEDULE.SCHEDULE_NOT_AVAILABLE
                                  }),this.$store.state.user.timeZoneName, this.$moment )
                                ;

        
          let arrayHours = arrayHoursTmp.filter((item)=>{
                                  return item.typeOfSchedule == Constants.TYPE_OF_SCHEDULE.SCHEDULE_NOT_AVAILABLE
                          })
                          .concat(arrayHoursConvert);
          //let arrayHours = response.data.entity.groupScheduleCounterProposalDetail;
     
          this.SelectBeginningDate = response.data.entity.beginningDate;
          let dataList = [];
          let id = 0
          this.arrayEditableSchedule = [];
          this.arraySchedulePrivate = [];
          this.listCalendar = [];
          this.listCalendarCounterInit = [];
          this.calendarOptions.events = [];

          arrayHours.forEach((element) => {
      
            let colorResquest = ""; 
            let titleClass = ""
            if(Constants.TYPE_OF_SCHEDULE.SCHEDULE_REQUEST==element.typeOfSchedule || Constants.TYPE_OF_SCHEDULE.COUNTERPROPOSAL_REQUEST_TIMETABLE == element.typeOfSchedule){
              let startOfWeek = this.$moment(element.startDate).startOf('week').toDate();
              let startOfWeekCurrent = this.$moment().startOf('week').toDate();
              let diff = this.$moment(startOfWeekCurrent).diff(this.$moment(startOfWeek), 'days')
            
              if(diff<0){
                diff = 0
              }
              this.dateStudent = new Date(this.$moment(element.startDate).add(diff,'d'))
              let dateInitData = this.$moment(element.startDate).add(diff,'d');
              let dateEndData = this.$moment(element.endDate).add(diff,'d')
              colorResquest = Constants.CALENDAR_STATUS.CONFIRM.COLOR; 
              titleClass = this.$t('reusables.student');
              this.arrayEditableSchedule.push(id)
              let jsonData = {
                  id: createEventId(),
                  title: titleClass,
                  description: "",
                  idx: id,
                  start: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                  end: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                  color: colorResquest,
                  editable: false
                };
                let data = {
                  id: id,
                  StartDate: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                  EndDate: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                  request : element.id != 0 ? true : false 
                };

                this.arraySchedulePrivate.push(data)
                dataList.push(jsonData);
                this.listCalendar.push(data);
            }
         
            if(Constants.TYPE_OF_SCHEDULE.SCHEDULE_CLASSES_TEACHER==element.typeOfSchedule){
              for (let index = 0; index <= 7; index = index+7) {

                let dateInitData = this.$moment(new Date(element.startDate)).add(index,'d');
                let dateEndData = this.$moment(new Date(element.endDate)).add(index,'d')
                colorResquest = Constants.CALENDAR_STATUS.PENDIENT.COLOR; 
                titleClass =  this.$t('reusables.class-scheduled')
                if(element.flagPlanTest){
                  titleClass = this.$t('reusables.test-class');//"Clase de prueba";
                }
              
                let jsonData = {
                  id: createEventId(),
                  title: titleClass,
                  description: "",
                  idx: id,
                  start: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                  end: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                  color: colorResquest,
                  editable: false
                };
                let data = {
                  id: id,
                  StartDate: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                  EndDate: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                  request : element.id != 0 ? true : false 
                };
                dataList.push(jsonData);
                this.listCalendar.push(data);
              }


              
            }
            if(Constants.TYPE_OF_SCHEDULE.SCHEDULE_NOT_AVAILABLE==element.typeOfSchedule){
                for (let index = 0; index <= 7; index = index+7) {

                let dateInitData = this.$moment(new Date(element.startDate)).add(index,'d');
                let dateEndData = this.$moment(new Date(element.endDate)).add(index,'d')
                colorResquest = Constants.CALENDAR_STATUS.UNAVAILABLE.COLOR; 
                titleClass =  this.$t('reusables.unavailable')
              
                let jsonData = {
                  id: createEventId(),
                  title: titleClass,
                  description: "",
                  idx: id,
                  start: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                  end: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                  color: colorResquest,
                  editable: false
                };
                let data = {
                  id: id,
                  StartDate: this.$moment(dateInitData).format('YYYY-MM-DDTHH:mm:ss'),
                  EndDate: this.$moment(dateEndData).format('YYYY-MM-DDTHH:mm:ss'),
                  request : element.id != 0 ? true : false 
                };
                dataList.push(jsonData);
                this.listCalendar.push(data);
              }



            
            }
          
           id++;
     
        });
       	let dataCounter = this.listCalendar.filter((currentValue)=>{
					         return currentValue.request ==true 
			  });
        this.listCalendarCounterInit=dataCounter;
        this.calendarOptions.events = dataList;

        this.calendarOptions.selectable=false;
        this.arrayListTeacherDetail.forEach(element => {
          element.color = '#b7b8bd'
        });
        if(this.arrayListTeacherDetail[index]){
          this.arrayListTeacherDetail[index].color = this.getColorStatus(item.stateProposal.value)
        }

        this.listItemExchanges = document.querySelectorAll('.card_teacher_carousel')
    
        for (let index = 0; index < this.listItemExchanges.length; index++) {
        
          this.listItemExchanges[index].classList.remove('active');
        }
        document.getElementById(divId).classList.add('active') 
        this.showLoading = false;
        this.flagDataFirst = true;

        setTimeout(() => {
          if(arrayHours.length>0){

              let d = new Date(this.dateStudent);
              let startOfWeek = this.$moment(d).startOf('week').toDate();
            
              let month = (parseInt(new Date(startOfWeek).getMonth())+1) <10 ? `0${parseInt(new Date(startOfWeek).getMonth())+1}` : parseInt(new Date(startOfWeek).getMonth())+1;
              let dayDate = parseInt(new Date(startOfWeek).getDate()) < 10  ? `0${parseInt(new Date(startOfWeek).getDate())}` : parseInt(parseInt(new Date(startOfWeek).getDate()));
              let calendarApi = this.$refs.fullCalendar.getApi(); 
            
              calendarApi.gotoDate(this.$moment(startOfWeek).format('YYYY')+"-"+month+"-"+dayDate);

          }
      }, 500);


      })
      .catch(err =>{
        console.log("err : ",err)
      })
    },

    showModalCancelRequest(){
      if(this.$store.state.datosSidebar.flagEdited){
             this.disabledDate =false;
      }else{
          this.disabledDate =true;
      }

        this.$refs.refCancelRequest.showModal(this.flagStateSend)
    },

    showModalConfirm(type){
        if(type == 1){
          this.typeConfirm = Constants.CONFIRM_REQUEST.ACCEPT;
        }else{
           this.typeConfirm = Constants.CONFIRM_REQUEST.SEND;
        }

        let arraySend = this.listCalendar.filter((currentValue)=>{
					return currentValue.request 
				})
			
        if(this.flagPlanTest){
          this.SelectBeginningDate =  arraySend[0].StartDate
        }

        
        this.$refs.refConfirm.showModal(this.dataTeacher,this.listCalendar,this.tabIndex == 0 ? 1:2, this.flagPlanTest,this.$store.state.datosSidebar.flagEdited,this.SelectBeginningDate,arraySend,this.flagStateSend,this.nameTeacher);
        
    },

    async getListTeacherDetail(){
    
      this.typeCancelRequest = Constants.CANCEL_REQUEST.CHILD_TEACHER
      let json = {
        listGroupScheduleProposalId:[this.numSave],
        ListTearchers: this.arrayListTeacher
      }

      await baseInstanceAxios
      .post(`${this.apiURL}/resources/GroupScheduleCounterProposal/ListScheduleCounterByTeachers`,json)
      .then(response => {
       
         response.data.list.forEach(element => {
            element.color = '#b7b8bd'
        });

        this.arrayListTeacherDetail = response.data.list
 
        if(this.arrayListTeacherDetail.length>0){
          if(this.student){
        
            if(this.student.flagNotification){
       
              this.getDetailTeacher(
                  this.student.groupScheduleCounterProposalId,
                  this.student.personTeacherId,
                  `teacher-id-${this.student.groupScheduleCounterProposalId}`,
                  this.student.className,
                  this.arrayListTeacherDetail[0],
                  0
                )

                this.student.flagNotification = false;
              
            }else{
              this.getDetailTeacher(
              this.arrayListTeacherDetail[0].id,
              this.arrayListTeacherDetail[0].personTeacherId,
              `teacher-id-${this.arrayListTeacherDetail[0].id}`,
              this.arrayListTeacherDetail[0].personTeacher.person.strFullName,
                 this.arrayListTeacherDetail[0],
                  0)
            }
          }else{
            this.getDetailTeacher(
              this.arrayListTeacherDetail[0].id,
              this.arrayListTeacherDetail[0].personTeacherId,
              `teacher-id-${this.arrayListTeacherDetail[0].id}`,
              this.arrayListTeacherDetail[0].personTeacher.person.strFullName,
                 this.arrayListTeacherDetail[0],
                  0)
          }
          
          //this.getDetailTeacher(this.arrayListTeacherDetail[0].id,this.arrayListTeacherDetail[0].personTeacherId,`teacher-id-${this.arrayListTeacherDetail[0].id}`,this.arrayListTeacherDetail[0].personTeacher.person.strFullName,this.arrayListTeacherDetail[0],0)
        }
      })
      .catch(err =>{
        console.log("err : ",err)
      })
    },

    enabledCalendar(){
    
       this.disabledDate = true;
   
      if(this.$store.state.datosSidebar.flagEdited){
         this.disabledDate = false;
      }
      this.calendarOptions.events.forEach(element => {
        element.editable = true;
      });
      //this.calendarOptions.editable=true;
      this.calendarOptions.selectable=true;
    
      this.calendarEdit = false;
      this.showButtonCancel = true;
    },

    editCalendarHorario(){
     
        this.btnSend = true;
        //this.btnOutCarousel = false;
        this.disabledDate = false
      
        this.calendarOptions.selectable=true;
        this.arrayEditableSchedule.forEach(id => {
            this.calendarOptions.events.forEach(element => {
              if(element.idx==id){
                element.editable = true;
              }
            });
        });

    
    },
    showCarouselPrev(countCarousel){
      this.flagResultList = false;
      if(countCarousel == null || countCarousel.length==0){
          if(this.tabIndex == 1){
            this.listScheduleProposalId= [];
          }else{
            this.arrayListTeacher = [];
          }
       this.flagResultList = false;
      }else{
         if(this.tabIndex == 1){
            this.listScheduleProposalId = countCarousel;
         }else{
           this.arrayListTeacher = countCarousel;
            this.titleTeacher = true;
            this.showCarousel = true; 
          }
          this.flagResultList = true;
      }

    },
    async showEventCarousel() {
      if(this.$store.state.datosSidebar.flagEdited){
         this.disabledDate = false;
      }
      else{
       this.disabledDate = true; 
      }
      this.flagDataFirst = false;
      this.showLoading = true;
      this.titleTeacher = !this.titleTeacher;
      this.showCarousel = !this.showCarousel;
      this.btnOutCarousel=true
      this.countBtnCarousel++

     
      await this.getListTeacherDetail(); 
    },

    backGetChild(){
      this.titleTeacher = !this.titleTeacher;
      this.showCarousel = !this.showCarousel;
      this.btnOutCarousel=false
      this.getListHoursCalendar();
    
      this.getListHours();
    },

    showTotalCarousel(){
   
      if(this.numberTeacher>0){
        this.totalCarousel=true;
        this.btnOutCarousel=false
      }else this.totalCarousel=false;
    },
  
    handleDateSelect(selectInfo) {
      
      this.eventCreated = selectInfo;
      this.$bvModal.show("modal-add-event");
    },

    closeModal() {
      this.showAlertModal = false;
      this.message = "";
      this.$bvModal.hide("modal-add-event");
    },

    getDateMinMax(minDateArray){
        this.minDate= new Date(minDateArray) 
 
        let d = new Date(minDateArray),     
        diff = d.getDate() + this.daysMaxSchedule
        this.maxDate= new Date(d.setDate(diff))
    
    },

    saveEvent(){

      this.showAlertModal = false;
      this.message = "";
      let fechaInicio = this.eventCreated.startStr;
      let dateSelectStart =new Date(fechaInicio)
      let dateEndNew = this.eventCreated.endStr

      if(this.flagPlanTest){
        let dateAfter = new Date(dateSelectStart.setMinutes(dateSelectStart.getMinutes()+this.maximoHorasCalendario*60))
        dateEndNew = dateAfter
      }

      let num = this.ObtenerRangoFecha(fechaInicio, dateEndNew,this.listCalendar)
        if(num == 0){
            if(this.tabIndex == 0){
              //TIPO DE SOLICITUD MASIVA
            
              if(this.titleTeacher){
                // SOLICITUD PENDIENTE PARA RESPONDER
            
                let dataTmp = this.listCalendar;
                let idx = 0;

                let ultId =
                  dataTmp.length == 0
                    ? 1 * -1000
                    : dataTmp[dataTmp.length - 1].id;
                ultId = ultId == null ? 0 : ultId;
                idx = ultId > 0 ? dataTmp.length * -1000 : ultId - 1000;

                let _eventItemMerge = ValidarMergeHorarios(this.calendarOptions.events, fechaInicio, dateEndNew, this.$moment);
            
                if(Object.keys(_eventItemMerge ).length != 0) { //si hay merge
                  this.listCalendar.forEach((obj, i) => {
                
                    if(obj.id == (_eventItemMerge.idx == 0 ? _eventItemMerge.id : parseInt(_eventItemMerge.idx, 10)) ) {
                      obj.StartDate = this.$moment(_eventItemMerge.start).format('YYYY-MM-DDTHH:mm:ss');
                      obj.EndDate = this.$moment(_eventItemMerge.end).format('YYYY-MM-DDTHH:mm:ss');
                      //obj.id = idx;
                    }
                  })
                
                }else{

                  let data2 = {
                    id: idx,
                    StartDate: this.$moment(fechaInicio).format('YYYY-MM-DDTHH:mm:ss'),
                    EndDate: this.$moment(dateEndNew).format('YYYY-MM-DDTHH:mm:ss'),
                    request: true
                  };

                  this.listCalendar.push(data2);
                  this.calendarOptions.events.push({
                    idx: idx,
                    id: createEventId(),
                    start: this.$moment(this.eventCreated.startStr).format('YYYY-MM-DDTHH:mm:ss') ,
                    end: this.$moment(dateEndNew).format('YYYY-MM-DDTHH:mm:ss'),
                    description: "",
                    title: this.titleCourse,
                    editable: true
                  });


                }
        
              }else{
                  // SOLICITUDES RESPONDIDA POR EL PROFESOR
                
                  let dataTmp = this.arraySchedulePrivate;
                  let idx = 0;

                  let ultId =
                    dataTmp.length == 0
                      ? 1 * -1000
                      : dataTmp[dataTmp.length - 1].id;
                  ultId = ultId == null ? 0 : ultId;
                  idx = ultId > 0 ? dataTmp.length * -1000 : ultId - 1000;

                  let _eventItemMerge = ValidarMergeHorarios(this.calendarOptions.events, fechaInicio, dateEndNew, this.$moment);
            
                  if(Object.keys(_eventItemMerge ).length != 0) { //si hay merge
                    this.listCalendar.forEach((obj, i) => {
                  
                      if(obj.id == (_eventItemMerge.idx == 0 ? _eventItemMerge.id : parseInt(_eventItemMerge.idx, 10)) ) {
                        obj.StartDate = this.$moment(_eventItemMerge.start).format('YYYY-MM-DDTHH:mm:ss');
                        obj.EndDate = this.$moment(_eventItemMerge.end).format('YYYY-MM-DDTHH:mm:ss');
                        //obj.id = idx;
                      }
                    })
                  
                  }else{

                    let data2 = {
                      id: idx,
                      StartDate: this.$moment(fechaInicio).format('YYYY-MM-DDTHH:mm:ss'),
                      EndDate: this.$moment(dateEndNew).format('YYYY-MM-DDTHH:mm:ss'),
                      request: true,
                      flagPlantTest:false
                    };
                    this.listCalendar.push(data2);
                    this.arraySchedulePrivate.push(data2);
                    
                    this.calendarOptions.events.push({
                      idx: idx,
                      id: createEventId(),
                      start: this.$moment(fechaInicio).format('YYYY-MM-DDTHH:mm:ss'),
                      description: "",
                      end: this.$moment(dateEndNew).format('YYYY-MM-DDTHH:mm:ss'),
                      title: this.titleCourse,
                      editable: true
                    });

                  }

 
              }
            }else{
              let dataTmp = this.arraySchedulePrivate;
              let idx = 0;

              let ultId =
                dataTmp.length == 0
                  ? 1 * -1000
                  : dataTmp[dataTmp.length - 1].id;
              ultId = ultId == null ? 0 : ultId;
              idx = ultId > 0 ? dataTmp.length * -1000 : ultId - 1000;


              //TIPO DE SOLICITUD PRIVADO
              var _eventItemMerge = ValidarMergeHorarios(this.calendarOptions.events, fechaInicio, dateEndNew, this.$moment);
               
              if(Object.keys(_eventItemMerge ).length != 0) { //si hay merge
                this.listCalendar.forEach((obj, i) => {
              
                  if(obj.request == true && obj.id == (_eventItemMerge.idx == 0 ? _eventItemMerge.id : parseInt(_eventItemMerge.idx, 10)) ) {
                    obj.StartDate = this.$moment(_eventItemMerge.start).format('YYYY-MM-DDTHH:mm:ss');
                    obj.EndDate = this.$moment(_eventItemMerge.end).format('YYYY-MM-DDTHH:mm:ss');
                    //obj.id = idx;
                  }
                })

                this.arraySchedulePrivate.forEach((obj, i) => {
              
                  if(obj.id == (_eventItemMerge.idx == 0 ? _eventItemMerge.id : parseInt(_eventItemMerge.idx, 10)) ) {
                    obj.StartDate = this.$moment(_eventItemMerge.start).format('YYYY-MM-DDTHH:mm:ss');
                    obj.EndDate = this.$moment(_eventItemMerge.end).format('YYYY-MM-DDTHH:mm:ss');
                  }
                })
              
              }else{

                
                let data2 = {
                  id: idx,
                  StartDate: this.$moment(fechaInicio).format('YYYY-MM-DDTHH:mm:ss'),
                  EndDate:   this.$moment(dateEndNew).format('YYYY-MM-DDTHH:mm:ss'),
                  request: true
                };
                this.listCalendar.push(data2);
                this.arraySchedulePrivate.push(data2);
                
                this.calendarOptions.events.push({
                  idx: idx,
                  id: createEventId(),
                  start: this.eventCreated.startStr,
                  description: "",
                  end: this.$moment(dateEndNew).format('YYYY-MM-DDTHH:mm:ss'),
                  title: this.titleCourse,
                  editable: true
                });


              }
 
                  
            }
        }else{
          this.message = `${this.$t('modals.modalViewSchedule.maximoHorasCalendario.1')} ${this.maximoHorasCalendario*60} ${this.$t('modals.modalViewSchedule.maximoHorasCalendario.2')} `;
					this.$bvToast.show("toast-equis-calendar-modal");
         
        }

          this.showAlertModal = false;
          this.$bvModal.hide("modal-add-event");        
    

     
    },
  
    handleEventClick(clickInfo) {
      console.log("clickInfo: ",clickInfo)
    },

    handleEvents(events) {
      let newEvents = events.event;
      let oldEvent = events.oldEvent;

      let fechaInicio = newEvents.startStr;
      let fechaFin = newEvents.endStr;
      let dateNow = new Date();
      let dateNowFormat = new Date(dateNow.getFullYear(),dateNow.getMonth(),dateNow.getDate(),0,0,0);
      let d = new Date(dateNowFormat);
      d = d.getDay() == 0 ? new Date(d.setDate(d.getDate() + 1)) : d;
      if(this.flagPlanTest){
          let dateCurrent = new Date();
          let newDateCurrent = new Date(dateCurrent.setMinutes(dateCurrent.getMinutes()-this.maximoHorasCalendario*60))
        
          let dataAfter = this.$moment(newDateCurrent).add(this.daysMaxSchedule-1, 'days')
        
          let dataStar = this.$moment(fechaInicio)
          let valueBefore = this.$moment(dataStar).isSameOrBefore(dataAfter);
          let valueAfter = this.$moment(new Date(fechaInicio)).isAfter(new Date());
        

            if(valueBefore && valueAfter){

              let dateSelectStart =new Date(fechaInicio)
              let dateAfter = (new Date(dateSelectStart.setMinutes(dateSelectStart.getMinutes()+ this.maximoHorasCalendario*60)))
         
               this.arraySchedulePrivate = this.arraySchedulePrivate.filter(function (e) {
        
                return (e.id != parseInt(oldEvent.extendedProps.idx) );
              });

              this.listCalendar = this.listCalendar.filter(function (e) {
              
                return (e.id != parseInt(oldEvent.extendedProps.idx) );
              });
              this.calendarOptions.events = this.calendarOptions.events.filter(
                function (e) {
                
                  return ( parseInt(e.id) != parseInt(oldEvent.id) );
                }
              )

              events.event.remove();
              let dataTmp = this.listCalendar;
              let idx = 0;
              let ultId =
                dataTmp.length == 0 ? 1 * -1000 : dataTmp[dataTmp.length - 1].id;
              ultId = ultId == null ? 0 : ultId;
              idx = ultId > 0 ? dataTmp.length * -1000 : ultId - 1000;
              let data2 = {
                id: idx,
                StartDate: this.$moment(newEvents.startStr).format('YYYY-MM-DDTHH:mm:ss'),
                EndDate: this.$moment(dateAfter).format('YYYY-MM-DDTHH:mm:ss'),
                request:true,
                flagPlantTest:false,
              };
              this.listCalendar.push(data2);
              this.arraySchedulePrivate.push(data2);
          
              this.calendarOptions.events.push({
                idx: idx,
                id: createEventId(),
                start: newEvents.startStr,
                end:  this.$moment(dateAfter).format('YYYY-MM-DDTHH:mm:ss'),
                title: this.titleCourse,
                editable: true,
              });
            }else{
              this.calendarOptions.events = this.calendarOptions.events.filter(
              function (e) {
                return ( parseInt(e.id) != parseInt(oldEvent.id) );
              })
          
              events.event.remove();
              this.calendarOptions.events.push({
    
                id: createEventId(),
                idx: oldEvent.extendedProps.idx,
                start: oldEvent.startStr,
                end: oldEvent.endStr,
                title: this.titleCourse,
                editable: true,
              });
           
            }
      }else{
          
        let dateSelectStart =new Date(fechaInicio);
        let dateSelectEnd = new Date(fechaFin);
        let dateEnd = null;

        let dateAfter = new Date(dateSelectStart.setHours(dateSelectStart.getHours()+ this.maximoHorasCalendario))

        if(dateSelectEnd.getTime() <dateAfter.getTime()){
          dateEnd = fechaFin
        }else{
          dateEnd = dateAfter
        }
        this.arraySchedulePrivate = this.arraySchedulePrivate.filter(function (e) {
          return (e.id != parseInt(oldEvent.extendedProps.idx) );
        });
            
        this.listCalendar = this.listCalendar.filter(function (e) {
          return (e.id != parseInt(oldEvent.extendedProps.idx) );
        });
        this.calendarOptions.events = this.calendarOptions.events.filter(function (e) {
          return ( parseInt(e.id) != parseInt(oldEvent.id) );
        });

        events.event.remove();

        let _eventItemMerge = ValidarMergeHorarios(this.calendarOptions.events, fechaInicio, fechaFin, this.$moment);

        if(Object.keys(_eventItemMerge ).length != 0) { //si hay merge

          this.listCalendar.forEach((obj, i) => {
            if(obj.id == (_eventItemMerge.idx == 0 ? _eventItemMerge.id : parseInt(_eventItemMerge.idx, 10)) ) {
              obj.StartDate = this.$moment(_eventItemMerge.start).format(this.formatDateSchedule);
              obj.EndDate = this.$moment(_eventItemMerge.end).format(this.formatDateSchedule);
            }
          });
          this.arraySchedulePrivate.forEach((obj, i) => {
            if(obj.id == (_eventItemMerge.idx == 0 ? _eventItemMerge.id : parseInt(_eventItemMerge.idx, 10)) ) {
              obj.StartDate = this.$moment(_eventItemMerge.start).format(this.formatDateSchedule);
              obj.EndDate = this.$moment(_eventItemMerge.end).format(this.formatDateSchedule);
            }
          }); 

        }else{

          let dataTmp = this.listCalendar;
          let idx = 0;
          let ultId =
            dataTmp.length == 0 ? 1 * -1000 : dataTmp[dataTmp.length - 1].id;
          ultId = ultId == null ? 0 : ultId;
          idx = ultId > 0 ? dataTmp.length * -1000 : ultId - 1000;

          let data2 = {
            id: idx,
            StartDate: this.$moment(newEvents.startStr).format('YYYY-MM-DDTHH:mm:ss'),
            EndDate:  this.$moment(dateEnd).format('YYYY-MM-DDTHH:mm:ss'),
            request:true,
            flagPlantTest:false,
          };
          this.listCalendar.push(data2);
          this.arraySchedulePrivate.push(data2);
            
          this.calendarOptions.events.push({
            idx: idx,
            id: createEventId(),
            start: newEvents.startStr,
            end: this.$moment(dateEnd).format('YYYY-MM-DDTHH:mm:ss'),
            title: this.titleCourse,
            editable: true,
          });

        }

       
           
      }

    },

    async getCourses() {
      this.showLoadingFirst = true;
      await baseInstanceAxios
        .get(
            `${this.apiURL}/resources/GroupRegisterSubjects/GetByGroupId?GroupsId=` +
            this.GroupId
        )
        .then((response) => {
          if (response.data) {
            if (response.data.entity) {
              if(this.flagPlanTest){
                this.titleCourse = this.$t('reusables.test-class'); //this.$t('reusables.test-class')//"Clase de prueba"
              }else{
                this.titleCourse = response.data.entity.subjectsName;
              }
              
              this.new_appointment.title = response.data.entity.subjectsName;
         
              if (response.data.entity.subjectsName.trim().length > 0) {
                this.showLoadingFirst = false;
                this.FlagGroupRegisterSubject = true;
                
              }
             
            }
          }
        });
    },

    async subirHorario(withFlag) {
     
      if (withFlag) {
        this.countCall = 1;
      }
      this.showButtonCancel = false;
      this.showSpinnerSave = true;
      this.showSpinner = true;
      let idOpcion = 1; // parseInt(this.$route.params.id);

      let arrayNewCalendar = [];


      this.listCalendar.forEach((element) => {
        let json = {
          StartDate: element.StartDate,
          EndDate: element.EndDate,
        };
        arrayNewCalendar.push(json);
      });

      if(this.flagPlanTest){
        
        this.SelectBeginningDate = this.listCalendar[0].StartDate
      }

      
      let data = {
        Schedule: {
          Id: this.numSave,
          SchedulesOptionsId: idOpcion,
          GroupsId: this.GroupId,
          Flag: withFlag ? true : this.flagState,
          BeginningDate: this.SelectBeginningDate,
          Status: withFlag ? true : this.flagState,
          FlagPlanTest: this.flagPlanTest
        },
        ScheduleDetail: arrayNewCalendar,
        FlagChangeTeacher : this.$store.state.datosSidebar.flagEdited,
        UserMail : this.$store.state.user.email
      };
     
      convertTimeCalendarEvents(data.ScheduleDetail, this.$store.state.user.timeZoneName, this.$moment);
			
      if(this.groupScheduleProposalId != 0){
        let flagContinue = await this.validateCounterProposal(this.groupScheduleProposalId);
        if(!flagContinue) {
          return;
        }
      }

      var api_url = _ctx + `/resources/GroupsCoursesLessons/SaveSchedule`;
      await baseInstanceAxios({
        method: "POST",
        url: api_url,
        data: data,
      })
        .then(() => {
          this.$bvModal.hide("modal-notes");
          this.getListHoursCalendar();
          this.getListHours();
          this.getDatosGenerales();
          if (withFlag) {
            //this.message = `${this.$t('calendario.text.0')} ${this.numSave == 0 ? this.$t('calendario.text.12') : this.$t('calendario.text.13') } ${this.$t('view-schedule.text.2')}`;
            this.message =  this.$t('calendario.text.mjeSubirHorario',{dato: this.numSave == 0 ? this.$t('calendario.text.12') : this.$t('calendario.text.13')});
            this.$bvToast.show("toast-check-calendar");
          }
          this.disabledDate = false
          this.showSpinner = false;
          this.showSpinnerSave = false;
        })
        .catch(function (error) {
          console.log(error);
          this.message = this.$t('error.error-registering-time');
          this.$bvToast.show("toast-equis-calendar");
          this.showSpinner = false;
          this.showSpinnerSave = false;
        });
    },

    showMethodAlert(textId) {
        document.getElementById(textId).blur()
        let d = new Date();
        let day = d.getDay(),
          diff = d.getDate() - day + (day == 0 ? -6 : 1);
      
        let dateStarHour = this.$moment(new Date(d.setDate(diff))).format('YYYY-MM-DD');
        
        let dateSelect = this.$moment(this.SelectBeginningDate).format('YYYY-MM-DD')
      
        this.flagAfter = this.$moment(dateSelect).isSameOrAfter(dateStarHour);
       
      if (this.listCalendar.length > 0) {
        if(this.flagAfter){
           this.$bvModal.show("modal-notes");
        }
       
      } else {
        this.showAlert();
      }
    },

    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },

    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
 
    ObtenerDuracion(fecha1, fecha2) {
      let minute = fecha2.diff(fecha1, "minutes");
      let minuteMod = (minute / 60) % 1;
      return minuteMod;
    },

    ObtenerRangoFechaSend(StartDate, EndDate,listCalendar) {
     
      var result = listCalendar.filter( (e) =>{
       
        return (
          (!(
            new Date(StartDate).getTime() == new Date(e.StartDate).getTime()
          ) &&
            new Date(StartDate).getTime() <= new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.StartDate).getTime() &&
            new Date(StartDate).getTime() < new Date(e.EndDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() <= new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() > new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() == new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() == new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.EndDate).getTime())
        );
      });
      return result.length;
    },

    ObtenerRangoFecha(StartDate, EndDate) {
      var result = this.listCalendar.filter(function (e) {
        return (
          (!(
            new Date(StartDate).getTime() == new Date(e.StartDate).getTime()
          ) &&
            new Date(StartDate).getTime() <= new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.StartDate).getTime() &&
            new Date(StartDate).getTime() < new Date(e.EndDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() <= new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() > new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() == new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() == new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.EndDate).getTime())
        );
      });
      return result.length;
    },

    ObtenerRangoFechaDisable(StartDate, EndDate,listCalendar) {
    
      var result = listCalendar.filter((e) => {
        /* if( (!(
            new Date(StartDate).getTime() == new Date(e.startDate).getTime()
          ) &&
            new Date(StartDate).getTime() <= new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.endDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.startDate).getTime() &&
            new Date(StartDate).getTime() < new Date(e.endDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.endDate).getTime()) ||
          (new Date(StartDate).getTime() <= new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() > new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.endDate).getTime()) ||
          (new Date(StartDate).getTime() == new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() == new Date(e.endDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.endDate).getTime())){
             if(!this.dataStudent.flagPlanTest){
                if(e.flagPlanTest){
        
                this.disabledDate = false;
                let num =  7
                this.minDate= new Date(e.startDate) 
                this.minDate.setDate(this.minDate.getDate()+1)
                let d = new Date(e.startDate),     
                diff = d.getDate() + num
                this.maxDate= new Date(d.setDate(diff))


              }
             }
            
        }*/
        return (
          (!(
            new Date(StartDate).getTime() == new Date(e.startDate).getTime()
          ) &&
            new Date(StartDate).getTime() <= new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.endDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.startDate).getTime() &&
            new Date(StartDate).getTime() < new Date(e.endDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.endDate).getTime()) ||
          (new Date(StartDate).getTime() <= new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() > new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.endDate).getTime()) ||
          (new Date(StartDate).getTime() == new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() == new Date(e.endDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.startDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.endDate).getTime())
        );
      });
      return result.length;
    },

    getTeacherInformationAndComments(id){
      
      let flag = this.lang == 'es' ? true : false;  
      baseInstanceAxios
        .get(this.API_URL + `/resources/PersonsTeachers/GeTeacherInformationAndCommentList?PersonTeacherId=${id}&flagLanguage=${flag}`)
        .then(response => {
          if(response.data != null && response.data.entity != null){

            this.teacherInformation = response.data.entity;
            this.$bvModal.show('modal-commentary-teacher');
          }
        }); 
    },

    getShowModalPerson:function(val){
        
      if(val.flag ==true){
        this.urlVideo = val.urlVideo;
        this.$bvModal.show("modal-content-video");
      } else{
        this.$bvModal.hide('modal-content-video');
      }
      
    },
    ShowModalRecomend(){
      let data = {
        personTeacherId: this.teacherInformation.id,
        nameTeacher: this.teacherInformation.person.strFullName,
        photoTeacher: "",
        typeScore: 2,
        qualification: 0,
        commentary: "", 
        id: 0,
        flagPublished: null
      };

      let params = {
        PersonStudentId: this.$store.state.user.personStudentId,
        PersonTeacherId: this.teacherInformation.id,
      };

      baseInstanceAxios
        .get(`${this.apiURL}/Resources/PersonsTeachers/GeTeacherCalificationByStudent`, {params})
        .then(resp => {
          if(resp.data.entity){
            data.photoTeacher = resp.data.entity.personsTeachers.person.photo;
            data.qualification = resp.data.entity.qualification;
            data.commentary = resp.data.entity.commentary;
            data.id = resp.data.entity.id;
            data.flagPublished = resp.data.entity.flagPublished;
          }

          this.$bvModal.hide('modal-commentary-teacher');
          this.$refs.modalScore.getShowModalScoreTeacher(data)
        });
    },
    loadExpiryReminders(){
      let self = this;
      baseInstanceAxios
        .get(`${this.apiURL}/resources/Groups/GetExpiringPlanReminders?Id=${this.$store.state.user.personStudentId}&IsTeacher=false&LeadDays=30`)
        .then(resp => {
          self.expiryReminders = (resp && resp.data && resp.data.list) ? resp.data.list : [];
          if (self.$refs.modalExpiry) { self.$refs.modalExpiry.show(self.expiryReminders); }
        })
        .catch(() => {});
    },
    expiryRemaining(r){
      let rem = (r.duration || 0) - (r.totalHoursSchedule || 0);
      return rem > 0 ? Math.round(rem * 100) / 100 : 0;
    },
    expiryReminderText(r){
      let en = this.$i18n.locale === 'en';
      let label = r.name ? ' (' + r.name + ')' : '';
      return en
        ? 'Your package' + label + ' expires on ' + r.strExpirationDate + ' and you still have ' + this.expiryRemaining(r) + ' unscheduled hour(s). Please schedule them before it expires.'
        : 'Tu paquete' + label + ' vence el ' + r.strExpirationDate + ' y aún tienes ' + this.expiryRemaining(r) + ' hora(s) sin agendar. Por favor agéndalas antes del vencimiento.';
    },
    checkPendingTeacherReview(){
      try {
        const raw = sessionStorage.getItem("pendingTeacherReview");
        if (!raw) return;
        sessionStorage.removeItem("pendingTeacherReview");
        const info = JSON.parse(raw);
        if (info && info.personTeacherId) {
          this.openTeacherReviewById(info.personTeacherId, info.nameTeacher || "");
        }
      } catch (e) { /* ignore */ }
    },
    openTeacherReviewById(personTeacherId, nameTeacher){
      let data = {
        personTeacherId: personTeacherId,
        nameTeacher: nameTeacher,
        photoTeacher: "",
        typeScore: 2,
        qualification: 0,
        commentary: "",
        id: 0,
        flagPublished: null
      };
      let params = {
        PersonStudentId: this.$store.state.user.personStudentId,
        PersonTeacherId: personTeacherId,
      };
      baseInstanceAxios
        .get(`${this.apiURL}/Resources/PersonsTeachers/GeTeacherCalificationByStudent`, { params })
        .then(resp => {
          if (resp.data.entity) {
            data.photoTeacher = resp.data.entity.personsTeachers.person.photo;
            data.qualification = resp.data.entity.qualification;
            data.commentary = resp.data.entity.commentary;
            data.id = resp.data.entity.id;
            data.flagPublished = resp.data.entity.flagPublished;
          }
          this.$refs.modalScore.getShowModalScoreTeacher(data);
        });
    },
    handleEvent(){
      this.message = this.$t('reusables.rating-successfully-recorded');
      this.$bvModal.show('toast-check-nav-bar');
    },
    async validateCounterProposal(groupScheduleCounterProposalId){
      let flagContinue = false;
      let flagType = true;//parametro para validar la solicitud y no la propuesta o contrapropuesta
      let params = { groupScheduleCounterProposalId,flagType};

      await baseInstanceAxios
        .get(`${this.apiURL}/resources/GroupScheduleCounterProposal/ValidateCounterProposalStudentByActive`, {params})
        .then((response) => {
          flagContinue = response.data.return;
          if(!response.data.return){
            let entity = response.data.entity;
            
            if(entity.flagProposalAcepted){
              this.messageValidate = this.$t("reusables.student-edited-schedule-11"); //GH => Cambiar
              this.typeResponseEvent = 1;
            }else{
              let objectStatus = Constants.STATUS_VALIDATION_COUNTER_PROPOSAL[entity.typeResult];
              if(objectStatus)
                this.messageValidate = this.lang == 'es' ? objectStatus.ES : objectStatus.EN;

							if(entity.flagCount){
                if(this.typeOption == 1){
                  this.typeResponseEvent = (entity.countProposalMassive == 0) ? 2 : 3;
								}else {
                  this.typeResponseEvent = (entity.countProposalDirects == 0) ? 4 : 3;
                }
              }else{
                this.typeResponseEvent = 1;
              }
            }
            this.$bvModal.show("modal-conflict-validate");
          }
        });
        
      return flagContinue;
    }
  }
};
</script>

<style>
  .icon-yout-disabled{
    fill: #b7b8bd !important;
    pointer-events: none !important;
  }
  
</style>